import {Component, ElementRef, HostListener, Input, ViewChild} from "@angular/core";
import Chart from "chart.js";
import * as PluginAnnotation from "chartjs-plugin-annotation";
import * as PluginStreaming from "chartjs-plugin-streaming";
import {Decimal} from "decimal.js";
import {Guid} from "guid-typescript";
import * as Konva from "konva";
import {FastLayer, Layer, Line, Stage} from "konva";
import {List} from "linqts";
import {Patient} from "../../model/patient";
import {
  AlgoScanBreakdown,
  Band,
  EmgScanBreakdown,
  HrvScanBreakdown,
  RomScanBreakdown,
  Scan,
  ScanViewBg,
  ScanViewType,
  ThermalScanBreakdown,
} from "../../model/scan";
import {
  AlgoScanData,
  EMGEnhancedData,
  EMGLiveData,
  EMGScanData,
  HRVPulseData,
  HRVScanData,
  ROMScanData,
  Scandata,
  ThermalRollingData,
  ThermalScanData,
} from "../../model/scandata";
import {Gender, RomResultTypes, RomTestTypes, ScanPosition, ScanTypes, SpinalLocation} from "../../model/weak-entities";
import "../../utils/GreensockKonvaPlugin";
import {delay, Dict} from "../../utils/utils";
import {Int64LE} from "int64-buffer";
import {BodyTypes, ScanPurpose} from "../../model/scanSettings";
import {LogService} from "../../providers/logging/log.service";


const maxBarWidth = 735;
// const barScale = 2;
const spineHeight = 50;

const fadeInTime = 0.3;

const energySvgData = "M77.6,40.1c-0.6-0.4-1.3-0.6-2-0.5c-0.1,0-0.2,0-0.3,0H59.1l1.8-31.8c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3  c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2  c-0.1-0.1-0.2-0.2-0.2-0.3c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.1-0.4-0.2  c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0  c-0.1,0-0.3,0-0.4,0c0,0,0,0-0.1,0c-0.2,0-0.3,0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.1-0.3,0.1-0.5,0.2c0,0-0.1,0.1-0.1,0.1  c-0.1,0.1-0.2,0.2-0.4,0.3c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0,0L21.6,54.8c0,0,0,0,0,0  c-0.1,0.1-0.2,0.3-0.3,0.5c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1,0,0.1c0,0.2,0,0.3,0,0.5  c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3  c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.5,0.1  c0,0,0,0,0,0c0,0,0,0,0,0h16.8l-1.8,31.8c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.2  c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3  c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1  c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,0.7-0.1c0,0,0.1,0,0.1,0  c0.2,0,0.3-0.1,0.5-0.2c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.3-0.3,0.5-0.5c0,0,0,0,0,0  l33.8-48.9C79.3,42.9,79,41.1,77.6,40.1z M47.1,56.6C47.1,56.6,47.1,56.5,47.1,56.6c0-0.2,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3  c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.2  c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1  c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0H29.8  l24.5-35.4l-1.4,24.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3  c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2  c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1  c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0h14.3L45.7,81L47.1,56.6  C47.1,56.6,47.1,56.6,47.1,56.6z";
const patternSvgData = "M332,901.999943 C332,898.687867 334.68795,896 337.996839,896 L353.995066,896 C359.516693,896 364,900.482 364,905.994973 L364,953.005027 C364,958.527085 359.528413,963 354.003162,963 L313.994009,963 C310.685298,963 308,960.306618 308,957.000057 L308,955.999943 C308,952.687031 310.679906,950 313.990179,950 L342.009821,950 C343.104154,950 344,949.100594 344,948.000057 L344,946.999943 C344,945.898679 343.098352,945 341.990442,945 L328.009558,945 C324.694012,945 322,942.308355 322,939.000057 L322,937.999943 C322,934.686913 324.682112,932 327.993102,932 L334.006898,932 C335.103172,932 336,931.100267 336,930.000057 L336,928.999943 C336,927.897759 335.101361,927 333.999974,927 L302.000026,927 C298.688671,927 296,924.30729 296,921.000057 L296,919.999943 C296,916.684307 298.682601,914 302.001884,914 L344.998116,914 C346.100219,914 347,913.099286 347,912.000057 L347,910.999943 C347,909.896927 346.102501,909 344.99998,909 L338.00002,909 C334.688668,909 332,906.307289 332,903.000057 L332,901.999943 Z M336,901.999943 L336,903.000057 C336,904.099495 336.899154,905 338.00002,905 L344.99998,905 C348.31107,905 351,907.687217 351,910.999943 L351,912.000057 C351,915.307498 348.310287,918 344.998116,918 L302.001884,918 C300.892309,918 300,918.892877 300,919.999943 L300,921.000057 C300,922.099494 300.899155,923 302.000026,923 L333.999974,923 C337.309624,923 340,925.687743 340,928.999943 L340,930.000057 C340,933.306516 337.315211,936 334.006898,936 L327.993102,936 C326.892854,936 326,936.894452 326,937.999943 L326,939.000057 C326,940.098429 326.902364,941 328.009558,941 L341.990442,941 C345.304543,941 348,943.686581 348,946.999943 L348,948.000057 C348,951.30619 345.316852,954 342.009821,954 L313.990179,954 C312.891426,954 312,954.893796 312,955.999943 L312,957.000057 C312,958.100166 312.897133,959 313.994009,959 L354.003162,959 C357.319008,959 360,956.318212 360,953.005027 L360,905.994973 C360,902.6914 357.307815,900 353.995066,900 L337.996839,900 C336.897061,900 336,900.897033 336,901.999943 Z M316,939.000057 C316,942.313087 313.317888,945 310.006898,945 L303.993102,945 C300.684789,945 298,942.306516 298,939.000057 L298,937.999943 C298,934.686913 300.682112,932 303.993102,932 L310.006898,932 C313.315211,932 316,934.693484 316,937.999943 L316,939.000057 Z M312,939.000057 L312,937.999943 C312,936.899733 311.103172,936 310.006898,936 L303.993102,936 C302.892854,936 302,936.894452 302,937.999943 L302,939.000057 C302,940.100267 302.896828,941 303.993102,941 L310.006898,941 C311.107146,941 312,940.105548 312,939.000057 Z M326,903.000057 C326,906.313131 323.312705,909 320.00077,909 L307.99923,909 C304.688225,909 302,906.307201 302,903.000057 L302,901.999943 C302,898.686869 304.687295,896 307.99923,896 L320.00077,896 C323.311775,896 326,898.692799 326,901.999943 L326,903.000057 Z M322,903.000057 L322,901.999943 C322,900.900417 321.101112,900 320.00077,900 L307.99923,900 C306.896292,900 306,900.89615 306,901.999943 L306,903.000057 C306,904.099583 306.898888,905 307.99923,905 L320.00077,905 C321.103708,905 322,904.10385 322,903.000057 Z";
const symmetrySvgData = 'M48,10.062a2.25058,2.25058,0,0,0-2.25,2.25V83.68652a2.25,2.25,0,0,0,4.5,0V12.312A2.25058,2.25058,0,0,0,48,10.062Z M32.21484,16.30914a2.89348,2.89348,0,0,0-2.76855,1.93622l-25.125,57.75A3,3,0,0,0,7.125,80.0625H32.25a3.00007,3.00007,0,0,0,3-3v-57.75A2.95692,2.95692,0,0,0,32.21484,16.30914ZM30.75,75.5625H9.41724L30.75,26.52856Z"/><path d="M91.61353,75.99536l-25.125-57.75A2.89318,2.89318,0,0,0,63.72,16.30914a2.957,2.957,0,0,0-3.03516,3.00336v57.75a2.99991,2.99991,0,0,0,3,3h25.125A2.99978,2.99978,0,0,0,91.61353,75.99536ZM65.18481,75.5625V26.52856l21.333,49.03394Z';

const colorWhite = "White";
const colorWhiteEnd = "White"; // Or 'Gainsboro'

const colorGreen = "#50C764";
const colorGreenEnd = "#50C764"; // Add new gradient ends here

const colorBlue = "#63BDFF";
const colorBlueEnd = "#63BDFF";

const colorRed = "#F86363";
const colorRedEnd = "#F86363";

const colorYellow = "#FCEE21";
const colorYellowEnd = "#FCEE21";

const colorGrey = "#9a9a9a";
const colorGreyEnd = "#9a9a9a";

const colorBlack = "#1c1c1c";
const colorBlackEnd = "#1c1c1c";

// How was this decided?
const lisasMagicAdjustmentNumber = 1.5;

@Component({
  selector: "scan-view",
  templateUrl: "scan-view.html",
})
export class ScanViewComponent {

  @Input() stageWidth: number = 2000;
  @Input() stageHeight: number = 2000;

  @Input()
  set scan(scan: Scan) {
    this._scan = scan;

    this.renderData().then(() => {
      this.stage.draw();

      this.notReady = false;
    });
  }

  get scan(): Scan {
    return this._scan;
  }
  @Input()
  set scanData(scanData: Scandata[]) {
    this._scanData = scanData;

    if (!this.notReady) {

      this.updateLiveView();

    }
  }

  get scanData(): Scandata[] {
    return this._scanData;
  }

  @ViewChild("scanViewArea") public scanViewArea: ElementRef;

  @Input()
  set patient(patient: Patient) {
    if(patient == undefined) return;
    this._patient = patient;
  }

  @Input() public scanViewType: ScanViewType;

  @Input() public showBias: boolean;
  @Input() public showDataValues: boolean;
  @Input() public showLegend: boolean;
  @Input() public showName: boolean;
  @Input() public backgroundImage: ScanViewBg = ScanViewBg.NONE;
  @Input() public animated: boolean = false;
  @Input() public chartColor: string = '#F86363';
  @Input()
  set emgEnhancedScaling(scale: number) {
    this._emgEnhancedScaling = scale;

    if (this.scanChart) {
      this.scanChart.options.scales.yAxes[0].ticks.max = this.emgEnhancedScaling;
      this.scanChart.update(0);
    } else if (this.data && !this.notReady) {
      for(let bl of this.bars.left) {
        bl.destroy();
      }
      for(let br of this.bars.right) {
        br.destroy();
      }
      this.bars.left = [];
      this.bars.right = [];
      this.reRenderEmgAmplitudeLive(this.emgPatternLiveStorage);
      this.stage.draw();
    }
  }

  get emgEnhancedScaling(): number {
    return this._emgEnhancedScaling;
  }
  @Input() public asImage: boolean = false;

  private _scanData: Scandata[];
  private _scan: Scan;
  private _patient: Patient;
  private _emgEnhancedScaling: number = 100000;
  private normScan: Scan;

  public stage: Stage;
  public background: Layer;
  public labels: Layer;
  public data: Layer;
  private lineGroupLeft: Layer;
  private lineGroupRight: Layer;
  private legend: FastLayer;
  private bias: FastLayer;
  private scanChart: Chart;
  private lastHrvPulse: HRVPulseData;
  private notReady: boolean = true;
  private containerId: string;
  // Scan view specifics
  private thermalLine: Line;
  private emgPatternLiveStorage: EMGScanData[]= [];
  public bars: {left: Array<Konva.Rect>,right: Array<Konva.Rect>} = {left: [],right: []};

  public imageSrc: string;
  constructor(private logger: LogService) {
    this.containerId = Guid.create().toString();
  }

  @HostListener("window:resize", ["$event"])
  public resizeStage() {
    const contWidth = this.scanViewArea.nativeElement.offsetWidth;
    const scale = contWidth / this.stageWidth;

    this.stage.width(this.stageWidth * scale);
    this.stage.height(this.stageHeight * scale);
    this.stage.scale({x: scale, y: scale});
    this.stage.draw();
  }

  /// endregion

  public ngOnDestroy() {
    if (this.scanChart) {
      this.scanChart.destroy();
    }
    if (this.stage) {
      this.stage.setHeight(0);
      this.stage.setWidth(0);
      this.stage.destroy();
    }
  }

  public async ngAfterViewInit() {
    // Stage
    this.setupStage();

    // Background
    this.setupBackground();

    if (this.scan && this.scanData) {
      throw new Error("Scan view must only accept scan or scandata, not both.");

    } else if (this.scan) {

      if (this.showBias && this.scan.Bias == undefined) {
        throw new Error("showBias flag requires bias value to be set on scan object.");
      }

      // Data
      await this.renderData();

      if (this.backgroundImage == ScanViewBg.NONE) {

        this.notReady = false;

        this.stage.draw();

      }

    } else if (this.scanData) {

      if (this.backgroundImage == ScanViewBg.NONE) {

        this.notReady = false;

        this.stage.draw();

      }
    }

  }

  public async genKonvaImage(url: string) {
    return new Promise((resolve, reject) => {
      // Create image
      let img = new Image();

      // Callback
      img.onload = () => {
        resolve(new Konva.Image({
          image: img,
          x: 0,
          y: 0,
          width: this.stageWidth,
          height: this.stageHeight
        }));
      };

      img.onerror = async () => {
        this.logger.warn(`genKonvaImage error: ${url}`, [{'SourceContext': 'scan-view.ts'}]);
        reject();
      };

      // Begin load
      img.src = url;
    });
  }

  public async getImage() {
    return new Promise(async (resolve, reject) => {

        let content = [];
        // let contentRendered = [];

        //content.push(this.background.getCanvas().toDataURL('image/png', 0.8));
        content.push(this.labels.getCanvas().toDataURL('image/png', 0.8));
        let dataLayer = this.data.getCanvas().toDataURL('image/png', 0.8);
        content.push(dataLayer);
        if (this.legend) content.push(this.legend.getCanvas().toDataURL('image/png', 0.8));
        if (this.bias) content.push(this.bias.getCanvas().toDataURL('image/png', 0.8));
        if (this.lineGroupLeft) content.push(this.lineGroupLeft.getCanvas().toDataURL('image/png',0.8));
        if (this.lineGroupRight) content.push(this.lineGroupRight.getCanvas().toDataURL('image/png',0.8));
        for (let x = 0; x < content.length; x++) {

          try {
            if(x == 1) {
              while(content[x] == 'data:,') {
                await delay(200);
                content[1] = this.data.getCanvas().toDataURL('image/png',0.8);
              }
            }
            let generatedImage: any = await this.genKonvaImage(content[x]);

            this.background.add(generatedImage);
          } catch (e) {
            this.logger.error(`Unable to generate image for ${this.scan.Id} - ${this.scanViewType} - layer was ${x}, trying again`, [{'SourceContext': 'scan-view.ts'}]);
          }

        }

      this.background.draw();

      resolve(this.background.getCanvas().toDataURL('image/jpeg', 0.8));

    });

  }

  /// region POSITIONING FUNCTIONS

  private getSpinePositions(cervical?: boolean) {
    const result = [];

    for (let x = 0; x <= (cervical ? 8 : 28); x ++) {
      result.push( {y: this.getSpinePositionFor(x, cervical), text: SpinalLocation[x], pos: x} );
    }

    return result;
  }

  private getSpinePositionFor(index: SpinalLocation, cervical?: boolean) {
    // Calc Y Base
    let ybase = 50;
    let spacing = 75;

    if (this.showName) {
      spacing = 65;
    }

    if (this.backgroundImage != ScanViewBg.NONE) {
      ybase = cervical ? 200 : 290;
      spacing = cervical ? 235 : 60;

      if (cervical && index === 0) {
        ybase = 290;
      } else if (index <= 7) {
        spacing = cervical ? 210 : 40;
      } else {
        ybase -= 160;
      }
    }

    return ybase + spacing * index;
  }

  // Gets width and height for line graph area
  private getThermalLineArea(cervical?: boolean) {

    const s1Pos = this.getSpinePositionFor(cervical ? SpinalLocation.T2 : SpinalLocation.S1, cervical);
    const c2Pos = this.getSpinePositionFor(SpinalLocation.C2, cervical);

    // let width = (this.stageWidth / 4) * 2;
    const width = this.backgroundImage != ScanViewBg.NONE ? this.stageWidth / 2 : this.stageWidth - 200;
    const height = s1Pos - c2Pos;
    const x = (this.stageWidth - width) / 2;
    const y = c2Pos + spineHeight / 2;

    return {x, y, width, height};

  }

  // Gets width and height for hrv rainbow area
  private getHrvRainbowArea() {

    const l3Pos = this.getSpinePositionFor(SpinalLocation.L3);
    const c1Pos = this.getSpinePositionFor(SpinalLocation.C1);

    // let width = (this.stageWidth / 4) * 2;
    const width = this.stageWidth * 0.5;
    const height = l3Pos - c1Pos;
    const x = (this.stageWidth - width) / 2;
    const y = c1Pos;

    return {x, y, width, height};

  }

  private getDtgArea(cervical?: boolean) {

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    const w = (this.stageWidth - width) / 2; // Total dtg area to work with

    const dtgwidth = w * 0.4; // leave a 5% margin
    const lx = w * 0.3;
    const rx = x + width + lx;

    return {
      left: {
        x: lx,
        y,
        width: dtgwidth,
        height,
      },
      right: {
        x: rx,
        y,
        width: dtgwidth,
        height,
      },
    };

  }

  private getDtgBarArea(centerWidth: number, dataWidth: number = 0) {

    let {x, y, width, height} = this.getThermalLineArea();
    width = centerWidth;
    x = (this.stageWidth / 2) - (width / 2);

    const w = (this.stageWidth - width - (dataWidth * 2)) / 2; // Total dtg area to work with

    const dtgwidth = w * 0.9; // leave a 5% margin
    const lx = dataWidth + w * 0.05;
    const rx = x + width + lx - dataWidth;

    return {
      left: {
        x: lx,
        y,
        width: dtgwidth,
        height,
      },
      right: {
        x: rx,
        y,
        width: dtgwidth,
        height,
      },
    };

  }

  /// endregion

  /// region SETUP

  // Sets up the stage and base variables
  private setupStage() {

    // this.resizeStage();
    const contWidth = this.scanViewArea.nativeElement.offsetWidth;
    const scale = contWidth / this.stageWidth;

    // Stage for drawing
    this.stage = new Konva.Stage({
      container: this.containerId,
      width: this.stageWidth * scale,
      height: this.stageHeight * scale,
      scale: {x: scale, y: scale},
    });

    // Background image layer
    this.background = new Konva.Layer({
      hitGraphEnabled: false,
      listening: false
    });

    // Text Layer
    this.labels = new Konva.Layer({
      hitGraphEnabled: false,
      listening: false
    });

    // Bars / Daya Layer
    this.data = new Konva.Layer({
      hitGraphEnabled: false,
      listening: false
    });

    // Adds to the stage
    this.stage.add(this.background);
    this.stage.add(this.labels);
    this.stage.add(this.data);

    // Legend layer
    if (this.showLegend) {
      this.legend = new Konva.FastLayer({
        hitGraphEnabled: false,
        listening: false
      });
      this.stage.add(this.legend);
    }

    // Bias layer
    if (this.showBias) {
      this.bias = new Konva.FastLayer({
        hitGraphEnabled: false,
        listening: false
      });
      this.stage.add(this.bias);
    }

  }

  private drawBlueman() {
    // New image to load
    const bg = new Image();

    const imagePrefix = this.backgroundImage == ScanViewBg.BLUEMAN ? "blueman" : "muscleman";

    const isCervical = this.scanViewType == ScanViewType.THERMAL_CERVICAL_NCM
      || this.scanViewType === ScanViewType.THERMAL_CERVICAL_LINE
      || this.scanViewType === ScanViewType.THERMAL_CERVICAL_SUMMARY
      || this.scanViewType === ScanViewType.THERMAL_CERVICAL_DTG;

    // On load, add to background
    bg.onload = () => {

      const blueman = new Konva.Image({
        x: 300,
        y: isCervical ? 150 : 0,
        image: bg,
        width: 1400,
        height: 2140,
        opacity: this.scanViewType == ScanViewType.THERMAL_LINE || this.scanViewType === ScanViewType.THERMAL_CERVICAL_LINE ? 0.25 : 1,
      });

      this.background.add(blueman);

      this.notReady = false;
      this.stage.draw();
    };

    let img = `assets/scanning/${imagePrefix}-man.jpg`;

    if (this._patient && this._patient.Gender.toString() == Gender[Gender.Female]) {
      img = `assets/scanning/${imagePrefix}-woman.jpg`;
    }

    if (isCervical){
      img = `assets/scanning/${imagePrefix}-cervical.jpg`;
    }

    bg.src = img;
  }

  private drawRainboxBack(){
    // New image to load
    const bg = new Image();

   // On load, add to background
    bg.onload = () => {
      const hrvBack = new Konva.Image({
        x: 500,
        y: 50,
        image: bg,
        width: 1000,
        height: 1575,
        opacity: 1,
      });

      this.background.add(hrvBack);
      this.setupHrvRainbowBackgroundOverlay();

      this.stage.draw();
    };

    bg.src = `assets/imgs/hrv_rainbowgraph.png`;
  }

  // Draws the background for the scan view
  private setupBackground() {
    // Create a white background
    const rect = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.stageWidth,
      height: this.stageHeight,
      fill: "white",
    });

    this.background.add(rect);

    if (this.showName) {
      this.setupViewName();
    }

    if (this.backgroundImage != ScanViewBg.NONE) {
      this.drawBlueman();
    }

    if(this.scanViewType == ScanViewType.HRV_RAINBOW) {
      this.drawRainboxBack();
    }

    switch (this.scanViewType) {
      case ScanViewType.THERMAL_NCM:
        this.setupNcmText();
        break;

      case ScanViewType.THERMAL_CERVICAL_NCM:
        this.setupNcmText(true);
        break;

      case ScanViewType.THERMAL_DTG:
        this.setupDtgText();
        break;

      case ScanViewType.THERMAL_CERVICAL_DTG:
        this.setupDtgText(true);
        break;

      case ScanViewType.THERMAL_LINE:
        this.setupThermalLineText();
        break;

      case ScanViewType.THERMAL_CERVICAL_LINE:
        this.setupThermalLineText(true);
        break;

      case ScanViewType.THERMAL_SUMMARY:
        this.setupThermalDtgText();
        break;

      case ScanViewType.THERMAL_CERVICAL_SUMMARY:
        this.setupThermalDtgText(true);
        break;

      case ScanViewType.EMG_AMPLITUDE:
      case ScanViewType.EMG_ASYMMETRY:
      case ScanViewType.EMG_ENHANCED:
      case ScanViewType.EMG_LIVE:
        this.setupEmgText();
        break;

      case ScanViewType.EMG_PATTERN:
        this.drawEmgBox();
        this.setupEmgText();
        break;

      case ScanViewType.ALGO:
        this.setupAlgoText();
        break;

      case ScanViewType.HRV_RAINBOW:
        this.setupHrvRainbowText();
        break;

      case ScanViewType.HRV_HEART_RATE:
      case ScanViewType.HRV_PULSE:
        this.setupHrvHeartRateText();
        break;

      case ScanViewType.ROM_GRAPH:
        this.setupRomText();
        break;
    }
  }

  private setupViewName() {

    let name;

    let yPos = this.getSpinePositionFor(SpinalLocation.S1) + 250;

    if (this.scanViewType == ScanViewType.EMG_PATTERN
      || this.scanViewType == ScanViewType.HRV_RAINBOW
      || this.scanViewType == ScanViewType.HRV_HEART_RATE
      || this.scanViewType == ScanViewType.ROM_GRAPH) {
      yPos = this.getSpinePositionFor(SpinalLocation.S1) + 150;
    }

    switch (this.scanViewType) {
      case ScanViewType.THERMAL_CERVICAL_SUMMARY:
      case ScanViewType.THERMAL_CERVICAL_DTG:
      case ScanViewType.THERMAL_CERVICAL_NCM:
      case ScanViewType.THERMAL_NCM:
      case ScanViewType.THERMAL_CERVICAL_LINE:
      case ScanViewType.THERMAL_LINE:
        name = "";
        break;

      case ScanViewType.THERMAL_SUMMARY:
        name = "Thermal Balance";
        break;

      case ScanViewType.EMG_AMPLITUDE:
        name = "Static EMG Tone";
        break;

      case ScanViewType.EMG_ASYMMETRY:
        name = "Postural EMG Balance";
        break;

      case ScanViewType.EMG_PATTERN:
        name = "Static EMG Pattern Graph";
        break;

      case ScanViewType.ALGO:
        name = "Pressure Algometry Graph";
        break;

      case ScanViewType.HRV_RAINBOW:
        name = "Adaptability Reserve Graph";

        // We need more space on the rainbow graph so move name to bottom
        // yPos = this.stageHeight - 150;
        break;

      case ScanViewType.HRV_HEART_RATE:
        name = "Instantaneous Heart Rate Graph";

        // We need more space for scan details at bottom
        // yPos = this.stageHeight - 350;
        break;

      case ScanViewType.HRV_PULSE:
        name = "Pulse Wave Profile";
        break;

      case ScanViewType.EMG_ENHANCED:
        name = "EMG Enhanced View";
        break;

      case ScanViewType.EMG_LIVE:
        name = "EMG Live View";
        break;

      case ScanViewType.ROM_GRAPH:
        name = "Graph";
        break;

      case ScanViewType.THERMAL_DTG:
        name = "Thermal DTG";
        break;
    }

    const bottomBar = new Konva.Rect({
      x: 50,
      y: yPos,
      width: this.stageWidth - 100,
      height: 100,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bottomText = new Konva.Text({
      x: this.stageWidth / 2,
      y: bottomBar.y() + bottomBar.height() / 2,
      text: name,
      fontSize: 42,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    bottomText.offsetX(bottomText.getWidth() / 2);
    bottomText.offsetY(bottomText.getHeight() / 2);

    if(name != '') {
      this.labels.add(bottomBar, bottomText);
    }

    // Also add labels for DTG lines on summary
    if (this.scanViewType == ScanViewType.THERMAL_SUMMARY) {
      const dtgArea = this.getDtgArea();

      const leftText = new Konva.Text({
        x: dtgArea.left.x + dtgArea.left.width / 2,
        y: bottomBar.y() + bottomBar.height() / 2,
        text: "Warm-Cool (DTG-L)",
        fontSize: 42,
        fontFamily: "Lato",
        fontStyle: "bold",
        fill: "black",
      });

      leftText.offsetX(leftText.getWidth() / 2);
      leftText.offsetY(leftText.getHeight() / 2);

      const rightText = new Konva.Text({
        x: dtgArea.right.x + dtgArea.right.width / 2,
        y: bottomBar.y() + bottomBar.height() / 2,
        text: "Cool-Warm (DTG-R)",
        fontSize: 42,
        fontFamily: "Lato",
        fontStyle: "bold",
        fill: "black",
      });

      rightText.offsetX(rightText.getWidth() / 2);
      rightText.offsetY(rightText.getHeight() / 2);

      this.labels.add(leftText, rightText);
    }
  }

  private async renderData() {
    switch (this.scanViewType) {
      case ScanViewType.THERMAL_NCM:
        this.renderThermalNcm();
        break;

      case ScanViewType.THERMAL_CERVICAL_NCM:
        this.renderThermalNcm(true);
        break;

      case ScanViewType.THERMAL_LINE:
        this.renderThermalLine();
        break;

      case ScanViewType.THERMAL_CERVICAL_LINE:
        this.renderThermalLine(1, true);
        break;

      case ScanViewType.THERMAL_DTG:
        this.renderThermalDtgBars();
        //this.renderThermalDtg();
        break;

      case ScanViewType.THERMAL_CERVICAL_DTG:
        this.renderThermalDtgBars(true);
        break;

      case ScanViewType.THERMAL_SUMMARY:
        this.setupThermalSummaryText();
        this.renderThermalSummary();
        this.renderThermalDtg();
        break;

      case ScanViewType.THERMAL_CERVICAL_SUMMARY:
        this.setupThermalSummaryText(true);
        this.renderThermalSummary(true);
        this.renderThermalDtg(true);
        break;

      case ScanViewType.THERMAL_NORMATIVE:
        //normal
        this.renderThermalNcm();
        break;

      case ScanViewType.EMG_AMPLITUDE:
        this.renderEmgAmplitude();
        break;

      case ScanViewType.EMG_ASYMMETRY:
        this.renderEmgAsymmetry();
        break;

      case ScanViewType.EMG_PATTERN:
        this.renderEmgPattern();
        break;

      case ScanViewType.EMG_NORMATIVE:
        this.renderEmgAmplitude();
        break;

      case ScanViewType.ALGO:
        this.renderAlgo();
        break;

      case ScanViewType.HRV_RAINBOW:
        this.renderHrvRainbow();
        this.renderHrvRainbowData();
        break;

      case ScanViewType.HRV_HEART_RATE:
        this.renderHrvHeartRate();
        break;

      case ScanViewType.HRV_NORMATIVE:
        //normal
        this.renderHrvRainbow();
        this.renderHrvRainbowData();
        break;

      case ScanViewType.ROM_GRAPH:
        this.renderRomGraph();
        break;
    }

    if(this.asImage) {
      let src:any = await this.getImage();
      this.imageSrc = src;

      this.stage.setHeight(0);
      this.stage.setWidth(0);
      this.stage.destroy();
    }
  }

  /// endregion

  /// region HRV

  // Setups up the text for HRV heart rate graph
  private setupHrvHeartRateText() {
    // Do nothing. This used to do animations
  }

  // Sets up HRV Pulse Chart
  private setupHrvPulseChart() {
    const ctx = this.data.getCanvas().getContext();

    // Little hack to pull the konva context for the chart
    // @ts-ignore
    this.scanChart = new Chart(ctx._context, {
      plugins: PluginStreaming,
      type: "line",
      data: {
        datasets: [{
            label: "Pulse Wave",
            backgroundColor: this.chartColor,
            borderColor: this.chartColor,
            data: [],
            fill: false,
            showLine: true,
            pointRadius: 0,
            borderWidth: 1,
            lineTension: 0,
        }],
      },
      options: {
        plugins: {
          streaming: {
            delay: 2000,
            duration: 5000,
            // frameRate: 20
          },
          datalabels: {
            display: false
          }
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        layout: {
          padding: {
            top: 10,
            left: 10,
            right: 10,
            bottom: this.showName ? 90 : 10,
          },
        },
        scales: {
          yAxes: [{
            id: 'y-axis-0',
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            },
            // scaleLabel: {
            //   display: true,
            //   labelString: 'Heart Rate'
            // },
            ticks: {
              // padding: 200
              // suggestedMin: 3000,
              // suggestedMax: 6000,
              // max: 33000,
              // min: -8000,
              min: 1000,
              max: 11000,
              callback: () => "",
            },
          }],
          xAxes: [{
            type: "realtime",
            time: {
              displayFormats: {
                second: "ss",
              },
            },
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            },
            // scaleLabel: {
            //   display: true,
            //   labelString: 'Seconds'
            // },
            position: "bottom",
            ticks: {
              // max: 5000
              callback: (v, i, vs) => "",
            },
          }],
        },
      },
    });
  }

  // Renders live data for HRV pulse
  private renderHrvPulseLive() {
    if (!this.scanChart) {
      this.setupHrvPulseChart();
    }

    if (!this.lastHrvPulse) {
      this.lastHrvPulse = this.scanData[0] as HRVPulseData;
      return;
    }

    const sd = this.scanData[0] as HRVPulseData;
    const prevSd = this.lastHrvPulse;

    const readingCount = prevSd.sampleCounts.length;
    const scale = (sd.timestamp - prevSd.timestamp) / readingCount;

    this.scanChart.data.datasets[0].data.push(...prevSd.sampleCounts.map((d, i) => {
      return {x: new Date(prevSd.timestamp + i * scale), y: d};
    }));

    this.lastHrvPulse = sd;

    this.scanChart.update({
      preservation: true
    });
  }

  // Renders HRV Heart rate graph
  private renderHrvHeartRate() {
    const ctx = this.data.getCanvas().getContext();

    const sd = this.scan.ScanData[0] as HRVScanData;

    const adjustedPpg = ScanViewUtils.filterHrvIbi(this.scan);
    if (adjustedPpg === undefined || adjustedPpg.length == 0) { return; }
    const adjustedScr = ScanViewUtils.normalizeHrvScr(this.scan);

    const ppgStart = adjustedPpg[0].TimeStamp / 10000000;
    const ppgStop = adjustedPpg[adjustedPpg.length - 1].TimeStamp / 10000000;
    const scanLength = sd.DCDuration / 1000;

    const ppgData = adjustedPpg.map((d) => {
      return {x: d.TimeStamp / 10000000, y: d.DataValue == 0 ? 0 : new Decimal(1000).mul(new Decimal(60).dividedBy(d.DataValue)).toNumber()};
    });
    const scrData = [];
    if(adjustedScr != undefined && adjustedScr.length > 0) {
      for (const scr of adjustedScr) {
        const ts = scr.TimeStamp / 10000000;
        if (ts >= ppgStart && ts <= ppgStop) {
          scrData.push({
            x: ts, y: scr.DataValue.toNumber(),
          });
        }
        else if (ts > ppgStop) {
          break;
        }
      }
    }

    //let ppgDif = ppgData[ppgData.length - 1].x - ppgData[0].x;
    //let scrDif = scrData[scrData.length - 1].x - scrData[0].x;

    let ppgDataChart = ppgData.map((d, i) => {
      return {x: i / (ppgData.length / (sd.DCDuration / 1000)), y: d.y};
    });

    let scrDataChart = scrData.map((d, i) => {
      return {x: i / (scrData.length / (sd.DCDuration / 1000)), y: d.y};
    });

    const chartData = {
      datasets: [
        {
          label: "Instantaneous Heart Rate",
          backgroundColor: colorRed,
          borderColor: colorRed,
          data: ppgDataChart,
          clip: 0,
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0,
          xAxisID: "ppgAxis",
        },
        {
          label: "Skin Conductance (Arousal)",
          backgroundColor: colorBlue,
          borderColor: colorBlue,
          data: scrDataChart,
          clip: 0,
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0,
          xAxisID: "ppgAxis",
        },
      ],
    };

    if (sd.EarClipFlag) {
      chartData.datasets.pop();
    }
    // Little hack to pull the konva context for the chart
    // @ts-ignore
    this.scanChart = new Chart(ctx._context, {
      plugins: PluginAnnotation,
      type: "scatter",
      data: chartData,
      options: {
        title: {
          display: true,
          text: `Scan Duration: ${scanLength / 60} ${(scanLength/60) > 1 ? 'Minutes' : 'Minute'}`,
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        annotation: {
          annotations: [
            {
              drawTime: "beforeDatasetsDraw",
              id: "hline",
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-1",
              value: 20,
              borderColor: "rgba(0, 0, 0, 0.3)",
              borderWidth: 1,
            },
          ],
        },
        layout: {
          padding: {
            top: 20,
            left: 20,
            right: 40,
            bottom: 90,
          },
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            },
            scaleLabel: {
              display: true,
              labelString: "Instantaneous Heart Rate",
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 150,
              stepSize: 20,
            },
          }],
          xAxes: [
            {
              id: "ppgAxis",
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: false,
              },
              scaleLabel: {
                display: true,
                labelString: "Seconds",
              },
              type: "linear",
              position: "bottom",
              ticks: {
                max: scanLength,
              },
            },
          ],
        },
      },
    });

    //this.timeline.add(() => {
      //this.scanChart.data = chartData;
      //this.scanChart.update(0);
    //});

  }

  // Setups the text for the HRV graph
  private setupHrvRainbowText() {

    // Draw the lines
    const {x, y, width, height} = this.getHrvRainbowArea();

    const yScale = height / 120;
    const xScale = width / 200;

    // Labels
    const leftAxis = new Konva.Text({
      x: x - 250,
      y:  y + height / 2,
      text: "Autonomic Activity",
      fontSize: 44,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
      opacity: 0.6,
      rotation: -90,
    });

    leftAxis.y(leftAxis.y() + leftAxis.getWidth() / 2);

    this.labels.add(leftAxis);

    const bottomAxis = new Konva.Text({
      x: x + width / 2,
      y:  y + height + 205,
      text: "Autonomic Balance",
      fontSize: 44,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
      opacity: 0.6,
    });

    bottomAxis.offsetX(bottomAxis.getWidth() / 2);

    this.labels.add(bottomAxis);

    const bottomAxis1 = new Konva.Text({
      x: x + xScale * 50,
      y:  y + height + 140,
      text: "Sympathetic",
      fontSize: 36,
      fontFamily: "Lato",
      fill: "black",
      opacity: 0.6,
    });

    const bottomAxis2 = new Konva.Text({
      x: x + xScale * 150,
      y:  y + height + 140,
      text: "Parasympathetic",
      fontSize: 36,
      fontFamily: "Lato",
      fill: "black",
      opacity: 0.6,
    });

    bottomAxis1.offsetX(bottomAxis1.getWidth() / 2);
    bottomAxis2.offsetX(bottomAxis2.getWidth() / 2);

    this.labels.add(bottomAxis1, bottomAxis2);

    // Zones

    const zone1 = new Konva.Text({
      x: x + 30,
      y:  y + 30,
      text: "Z1",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "white",
    });

    const zone2 = new Konva.Text({
      x: x + width - 30,
      y:  y + 30,
      text: "Z2",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "white",
    });

    zone2.offsetX(zone2.getWidth());

    const zone3 = new Konva.Text({
      x: x + 30,
      y:  y + height - 30,
      text: "Z3",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "white",
    });

    zone3.offsetY(zone3.getHeight());

    const zone4 = new Konva.Text({
      x: x + width - 30,
      y:  y + height - 30,
      text: "Z4",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "white",
    });

    zone4.offset({x: zone4.getWidth(), y: zone4.getHeight()});

    const zone5 = new Konva.Text({
      x: x + width / 2 - 30,
      y:  y + 200,
      text: "Z5",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "white",
    });

    this.labels.add(zone1, zone2, zone3, zone4, zone5);

    for (let i = 0; i <= 120; i += 5) {
      const length = i % 4 == 0 ? 50 : 25;

      const line = new Konva.Line({
        points: [x, y + height - yScale * i, x - length, y + height - yScale * i],
        stroke: "black",
        strokeWidth: 2,
        opacity: length / 50,
      });

      this.labels.add(line);

      if (length == 50) {
        const textMarker = new Konva.Text({
          x: x - length - 20,
          y:  y + height - yScale * i,
          text: i.toString(),
          fontSize: 36,
          fontFamily: "Lato",
          fontStyle: "bold",
          fill: "black",
        });

        textMarker.offset({
          x: textMarker.getWidth(),
          y: textMarker.getHeight() / 2,
        });

        this.labels.add(textMarker);
      }
    }

    for (let i = 0; i <= 200; i += 25) {
      const length = i % 50 == 0 ? 50 : 25;

      const line = new Konva.Line({
        points: [x + xScale * i, y + height, x + xScale * i, y + height + length],
        stroke: "black",
        strokeWidth: 2,
        opacity: length / 50,
      });

      this.labels.add(line);

      if (length == 50) {
        let markerText;

        switch (i) {
          case 0:
          case 200:
            markerText = "0";
            break;

          case 100:
            markerText = "100";
            break;

          case 50:
            markerText = "50(S)";
            break;

          case 150:
            markerText = "50(P)";
            break;
        }

        const textMarker = new Konva.Text({
          x: x + xScale * i,
          y:  y + height + length + 20,
          text: markerText,
          fontSize: 36,
          fontFamily: "Lato",
          fontStyle: "bold",
          fill: "black",
        });

        textMarker.offset({
          x: textMarker.getWidth() / 2,
          y: 0,
        });

        this.labels.add(textMarker);
      }
    }
  }

  private setupHrvRainbowBackgroundOverlay() {
    const {x, y, width, height} = this.getHrvRainbowArea();

    const bgGroup = new Konva.Group();

    const hline = new Konva.Line({
      points: [x, y + height / 2 - 100, x + width, y + height / 2 - 100],
      strokeWidth: 4,
      stroke: "black",
    });

    const vline = new Konva.Line({
      points: [x + width / 2, y, x + width / 2, y + height],
      strokeWidth: 4,
      stroke: "black",
    });

    const safeWidth = width / 3.1;
    const yScale = height / 120;
    const safeHeight = yScale * 35;

    const safeZone = new Konva.Line({
      points: [
        x + width / 2 - safeWidth / 2, y + yScale * 8, // 120 - 8 = 112
        x + width / 2 + safeWidth / 2, y + yScale * 8,
        x + width / 2 + safeWidth / 2, y + yScale * 43, // 120 - 43 = 77
        x + width / 2 - safeWidth / 2, y + yScale * 43
      ],
      strokeWidth: 6,
      stroke: "black",
      lineCap: "round",
      lineJoin: "round",
      fill: "rgba(0,0,0,0)",
      dash: [5, 15],
      closed: true,
    });

    bgGroup.add(hline, vline, safeZone);
    this.background.add(bgGroup);
  }

  private renderHrvRainbow() {

    const {x, y, width, height} = this.getHrvRainbowArea();

    const yScale = height / 120;
    const xScale = width / 200;

    const sd: HRVScanData = this.scan.ScanData[0] as HRVScanData;

    let abi = sd.AutonomicBalance;
    if(sd.ABIndicator === true) {
      abi = (100 - abi) + 100;
    }
    const score = new Konva.Circle({
      x: x + abi * xScale,
      y: y + height - sd.AutonomicActivity * yScale,
      radius: 25,
      strokeWidth: 4,
      stroke: "black",
      fill: "white",
    });

    this.data.add(score);
  }

  private renderHrvRainbowData() {

    const sd = this.scan.ScanData[0] as HRVScanData;

    const bar1 = new Konva.Rect({
      x: 50,
      y: this.getSpinePositionFor(SpinalLocation.L3) + 270,
      width: (this.stageWidth - 150) / 2,
      height: 75,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bar2 = new Konva.Rect({
      x: bar1.x() + bar1.width() + 50,
      y: this.getSpinePositionFor(SpinalLocation.L3) + 270,
      width: (this.stageWidth - 150) / 2,
      height: 75,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bar1Text = new Konva.Text({
      x: bar1.x() + 150,
      y: bar1.y() + bar1.height() / 2,
      text: "Autonomic Activity Index",
      fontSize: 36,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar1ValText = new Konva.Text({
      x: bar1Text.x() + bar1Text.width() + ((bar1.x() + bar1.width()) - (bar1Text.x() + bar1Text.width())) / 2,
      y: bar1.y() + bar1.height() / 2,
      text: sd.AutonomicActivity.toFixed(2),
      fontSize: 40,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar2Text = new Konva.Text({
      x: bar2.x() + 150,
      y: bar2.y() + bar2.height() / 2,
      text: "Autonomic Balance Index",
      fontSize: 36,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar2ValText = new Konva.Text({
      x: bar2Text.x() + bar2Text.width() + ((bar2.x() + bar2.width()) - (bar2Text.x() + bar2Text.width())) / 2,
      y: bar2.y() + bar2.height() / 2,
      text: sd.AutonomicBalance.toFixed(2),
      fontSize: 40,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    bar1Text.offset({x: 0, y: bar1Text.getHeight() / 2});
    bar2Text.offset({x: 0, y: bar2Text.getHeight() / 2});

    bar1ValText.offset({x: bar1ValText.getWidth() / 2, y: bar1ValText.getHeight() / 2});
    bar2ValText.offset({x: bar2ValText.getWidth() / 2, y: bar2ValText.getHeight() / 2});

    this.labels.add(bar1, bar2, bar1Text, bar2Text, bar1ValText, bar2ValText);
  }

  /// endregion

  /// region ROM

  // Setups up the text for HRV heart rate graph
  private setupRomText() {
    // Do nothing. This used to do animations.
  }

  // Renders HRV Heart rate graph
  private renderRomGraph() {
    const ctx = this.data.getCanvas().getContext();

    const sd = this.scan.ScanData as ROMScanData[];
    let tests = [];
    let roms = [];
    let norms = [];

    for (let data of sd.sort((d1: ROMScanData, d2: ROMScanData) => d1.TestType - d2.TestType)) {
      tests.push(ScanViewUtils.getRomLabel(data.TestType, data.ResultType));
      roms.push(data.DataValue);
      norms.push(ScanViewUtils.getRomNorm(data.TestType, data.ResultType));
    }

    const chartData = {
      labels: tests,
      datasets: [
        {
          label: "Pt. ROM",
          backgroundColor: colorBlue,
          borderColor: colorBlue,
          data: roms,
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0,
        },
        {
          label: "Norm ROM",
          backgroundColor: '#f1f1f1',
          borderColor: '#f1f1f1',
          data: norms,
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0,
        },
      ],
    };

    // Little hack to pull the konva context for the chart
    // @ts-ignore
    this.scanChart = new Chart(ctx._context, {
      // plugins: PluginAnnotation,
      type: "bar",
      data: {},
      options: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return tooltipItem.yLabel + '°';
            },
          }
        },
        title: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        layout: {
          padding: {
            top: 20,
            left: 20,
            right: 40,
            bottom: 90,
          },
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              callback: function(value, index, values) {
                return value + '°';
              }
            }
          }]
        }

      },
    });

    this.scanChart.data = chartData;
    this.scanChart.update(0);

  }

  /// endregion

  /// region ALGO

  // Draws the spinal text for spinal scan views
  // Only used for scan name bar currently. Text for this view is added to data layer during rendering
  private setupAlgoText() {

    // For all spine locations
    for (const loc of this.getSpinePositions()) {

      if (loc.pos <= 24) {

        // Make text
        const textR = new Konva.Text({
          y: loc.y,
          text: loc.text,
          fontSize: 38,
          fontFamily: "Lato",
          fontStyle: "bold",
          fill: "#0f477a",
        });

        textR.x(this.stageWidth - textR.width() - 50);

        // Add to layer
        this.labels.add(textR);

        // Make text
        const textL = new Konva.Text({
          y: loc.y,
          text: loc.text,
          fontSize: 38,
          fontFamily: "Lato",
          fontStyle: "bold",
          fill: "#0f477a",
        });

        textL.x(50);

        // Add to layer
        this.labels.add(textL);
      }
    }
  }

  // Renders Algometry data
  private renderAlgo() {

    for (const scandata of this.scan.ScanData
      .filter((d: AlgoScanData) => d.LeftValue.gt(0) || d.CenterValue.gt(0) || d.RightValue.gt(0))
      .sort((d1: AlgoScanData, d2: AlgoScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as AlgoScanData;

      let x, y, width, height;

      height = spineHeight * .75;
      y = this.getSpinePositionFor(sd.SpinalLocation) + spineHeight * .125;

      x = 225;
      width = (this.stageHeight - x * 2) / 3;

      let color = [0, colorGrey, 1, colorGreyEnd];
      if(!sd.BaselineFlag) {
        color = ScanViewUtils.getAlgoBarColor(sd,<AlgoScanData[]>this.scan.ScanData);
      }

      if (sd.LeftValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.LeftValue, color, 1);
      }

      if (sd.CenterValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.CenterValue, color, 2);
      }

      if (sd.RightValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.RightValue, color, 3);
      }

    }

    if (this.showLegend) {
      this.renderLegend()
    }
  }

  // Renders Ncm data
  private renderAlgoLive() {

    // Live uses last value
    const sd = this._scanData[this._scanData.length - 1] as AlgoScanData;
    // Checks for any erronious values
    if (sd.SpinalLocation != undefined) {

      let x, y, width, height;

      height = spineHeight * .75;
      y = this.getSpinePositionFor(sd.SpinalLocation) + spineHeight * .125;

      x = 225;
      width = (this.stageHeight - x * 2) / 3;

      let color = [0, colorGrey, 1, colorGreyEnd];
      if(!sd.BaselineFlag) {
        color = ScanViewUtils.getAlgoBarColor(sd,<AlgoScanData[]>this._scanData);
      }
      if (sd.LeftValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.LeftValue, color, 1);
      }

      if (sd.CenterValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.CenterValue, color, 2);
      }

      if (sd.RightValue.greaterThan(0)) {
        this.renderAlgoBar(sd.SpinalLocation, sd.RightValue, color, 3);
      }

    }

  }

  /// endregion

  /// region EMG

  private drawEmgBox() {
    const {x, y, width, height} = this.getThermalLineArea();
    // Create a white background
    const rect = new Konva.Rect({
      x: x-80,
      y: y-40,
      width: width+175,
      height: height+48,
      stroke: "grey",
      fill: null
    });

    this.labels.add(rect);
  }

  // Draws the spinal text for spinal scan views
  // Only used for scan name bar currently. Text for this view is added to data layer during rendering
  private setupEmgText() {
    // Do nothing. This used to animate
  }

  // Sets up EMG Enhanced Chart
  private setupEmgEnhancedChart() {
    const ctx = this.data.getCanvas().getContext();

    // Create margins
    let contWidth = this.scanViewArea.nativeElement.offsetWidth;

    // Little hack to pull the konva context for the chart
    // @ts-ignore
    this.scanChart = new Chart(ctx._context, {
      type: "scatter",
      data: {
        datasets: [{
          label: "Raw Data",
          backgroundColor: this.chartColor,
          borderColor: this.chartColor,
          data: [],
          fill: true,
          showLine: true,
          pointRadius: 0,
          borderWidth: 1,
          lineTension: 0,
        }],
      },
      options: {
        plugins: {
          datalabels: {
            display: false
          }
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        legend: {
          display: false
        },
        responsiveAnimationDuration: 0,
        layout: {
          padding: {
            top: contWidth * 0.05,
            left: 0,
            right: contWidth * 0.05,
            bottom: this.showName ? contWidth * 0.15 : 0,
          },
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            },
            ticks: {
              padding: 0,
              max: this.emgEnhancedScaling,
              min: 0,
              display: false
            },
          }],
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            },
            position: "bottom",
            ticks: {
              padding: 0,
              max: 240,
              display: false
            },
          }],
        },
      },
    });
  }

  // Renders live data for EMG Enhanced
  private renderEmgEnhancedLive() {
    if (!this.scanChart) {
      this.setupEmgEnhancedChart();
    }

    let sd = <EMGEnhancedData>this.scanData[0];

    let data = sd.sampleCounts.map((d, i) => {return {x: i, y: d}});

    this.scanChart.data.datasets[0].data = data;

    this.scanChart.update(0);
  }

  // Sets up EMG Line Chart
  private setupEmgLineChart() {
    const ctx = this.data.getCanvas().getContext();

    // Little hack to pull the konva context for the chart
    // @ts-ignore
    this.scanChart = new Chart(ctx._context, {
      plugins: PluginStreaming,
      type: "line",
      data: {
        datasets: [{
          label: "Left RMS",
          backgroundColor: '#F86363',
          borderColor: '#F86363',
          data: [],
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0
        },
        {
          label: "Right RMS",
          backgroundColor: '#63BDFF',
          borderColor: '#63BDFF',
          data: [],
          fill: false,
          showLine: true,
          pointRadius: 0,
          borderWidth: 2,
          lineTension: 0
        }
        ],
      },
      options: {
        plugins: {
          streaming: {
            delay: 600,
            duration: 15000,
            // frameRate: 20
          },
          datalabels: {
            display: false
          }
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        layout: {
          padding: {
            top: 10,
            left: 10,
            right: 10,
            bottom: this.showName ? 90 : 10,
          },
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            },
            // scaleLabel: {
            //   display: true,
            //   labelString: 'Heart Rate'
            // },
            ticks: {
              // padding: 200
              max: 25,
              min: 0,
              callback: (v) => `${v} μV`,
            },
          }],
          xAxes: [{
            type: "realtime",
            time: {
              unit: 'second',
              distribution: 'series',
              displayFormats: {
                second: "ss",
              },
            },
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            },
            // scaleLabel: {
            //   display: true,
            //   labelString: 'Seconds'
            // },
            position: "bottom",
            ticks: {
              // max: 5000
              callback: (v, i, vs) => "",
            },
          }],
        },
      },
    });
  }

  // Renders live data for EMG Line
  private renderEmgLineLive() {
    if (!this.scanChart) {
      this.setupEmgLineChart();
    }

    const sd = this.scanData[0] as EMGLiveData;
    if (!sd) return;

    if (sd.reset) {
      this.scanChart.data.datasets[0].data = [];
      this.scanChart.data.datasets[1].data = [];
      this.scanChart.options.plugins.streaming.pause = true;
      setTimeout(() => {
        this.scanChart.options.plugins.streaming.pause = false;
      }, 2500);
      return;
    }

    this.scanChart.data.datasets[0].data.push({x: new Date(sd.timestamp), y: sd.leftValue});
    this.scanChart.data.datasets[1].data.push({x: new Date(sd.timestamp), y: sd.rightValue});

    //this.scanChart.update(0);
    this.scanChart.update({
      preservation: true
    });
  }

  // Renders EMG pattern graph
  private renderEmgPattern(duration: number = 0.75) {

    const {x, y, width, height} = this.getThermalLineArea();

    const xScale = width / (ScanViewUtils.getEmgMaxValue() * 2);

    const leftPoints = [];
    const rightPoints = [];

    const leftHypo = [];
    const leftNorm = [];
    const leftMild = [];
    const leftMod = [];
    const leftSig = [];
    let leftNormArea = [];

    const rightHypo = [];
    const rightNorm = [];
    const rightMild = [];
    const rightMod = [];
    const rightSig = [];
    let rightNormArea = [];

    // Generates the lines for the mean data
    for (let pos = 0; pos <= 28; pos ++) {
      const calcData = ScanViewUtils.EmgCalcData[pos];

      if (calcData.LeftMean == 0) { continue; }

      // Hypo
      leftHypo.push((calcData.LeftMean - calcData.LeftSd + lisasMagicAdjustmentNumber) * -xScale);
      leftHypo.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      rightHypo.push((calcData.RightMean - calcData.LeftSd + lisasMagicAdjustmentNumber) * xScale);
      rightHypo.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      // Norm
      leftNorm.push((calcData.LeftMean + lisasMagicAdjustmentNumber) * -xScale);
      leftNorm.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      rightNorm.push((calcData.RightMean + lisasMagicAdjustmentNumber) * xScale);
      rightNorm.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      // Mild
      leftMild.push((calcData.LeftMean + calcData.LeftSd + lisasMagicAdjustmentNumber) * -xScale);
      leftMild.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      rightMild.push((calcData.RightMean + calcData.LeftSd + lisasMagicAdjustmentNumber) * xScale);
      rightMild.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      // Mod
      leftMod.push((calcData.LeftMean + calcData.LeftSd * 2 + lisasMagicAdjustmentNumber) * -xScale);
      leftMod.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      rightMod.push((calcData.RightMean + calcData.LeftSd * 2 + lisasMagicAdjustmentNumber) * xScale);
      rightMod.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      // Sig
      leftSig.push((calcData.LeftMean + calcData.LeftSd * 3 + lisasMagicAdjustmentNumber) * -xScale);
      leftSig.push(this.getSpinePositionFor(pos) + spineHeight / 2);

      rightSig.push((calcData.RightMean + calcData.LeftSd * 3 + lisasMagicAdjustmentNumber) * xScale);
      rightSig.push(this.getSpinePositionFor(pos) + spineHeight / 2);
    }

    // We have to use this map because the points array is flat, so we want to reverse it in sets of two
    let reversed = [];
    leftHypo.map((d, i, arr) => {if (i != 0 && i % 2 != 0) { reversed.unshift(arr[i - 1], d); }});
    leftNormArea = leftMild.concat(reversed);

    reversed = [];
    rightHypo.map((d, i, arr) => {if (i != 0 && i % 2 != 0) { reversed.unshift(arr[i - 1], d); }});
    rightNormArea = rightMild.concat(reversed);

    // Generates the lines for the actual scan
    for (const scandata of this.scan.ScanData
      .filter((d: EMGScanData) => d.SpinalLocation != undefined)
      .sort((d1: EMGScanData, d2: EMGScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as EMGScanData;

      const leftValue = sd.LeftValue.negated();

      const rightValue = sd.RightValue;

      // Make text
      const text = new Konva.Text({
        x: this.stageWidth / 2,
        y: this.getSpinePositionFor(sd.SpinalLocation),
        text: SpinalLocation[sd.SpinalLocation],
        fontSize: 38,
        fontFamily: "Lato",
        fontStyle: "bold",
        fill: "#0f477a",
      });

      // Set offset for centering
      text.offsetX(text.getWidth() / 2);

      // Add to layer
      this.data.add(text);

      leftPoints.push(Math.max(leftValue.minus(lisasMagicAdjustmentNumber).toNumber() * xScale, -width/1.75));
      leftPoints.push(this.getSpinePositionFor(sd.SpinalLocation) + spineHeight / 2);
      rightPoints.push(Math.min(rightValue.plus(lisasMagicAdjustmentNumber).toNumber() * xScale, width/1.75));
      rightPoints.push(this.getSpinePositionFor(sd.SpinalLocation) + spineHeight / 2);
    }

    const leftLine = new Konva.Line({
      points: leftPoints,
      stroke: "black",
      strokeWidth: 13,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightLine = new Konva.Line({
      points: rightPoints,
      stroke: "black",
      strokeWidth: 13,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // Hypo
    const leftHypoLine = new Konva.Line({
      points: leftHypo,
      stroke: colorYellow,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightHypoLine = new Konva.Line({
      points: rightHypo,
      stroke: colorYellow,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // Norm
    const leftNormLine = new Konva.Line({
      points: leftNorm,
      stroke: colorWhite,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightNormLine = new Konva.Line({
      points: rightNorm,
      stroke: colorWhite,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // Mild
    const leftMildLine = new Konva.Line({
      points: leftMild,
      stroke: colorGreen,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightMildLine = new Konva.Line({
      points: rightMild,
      stroke: colorGreen,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // Mod
    const leftModLine = new Konva.Line({
      points: leftMod,
      stroke: colorBlue,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightModLine = new Konva.Line({
      points: rightMod,
      stroke: colorBlue,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // Sig
    const leftSigLine = new Konva.Line({
      points: leftSig,
      stroke: colorRed,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    const rightSigLine = new Konva.Line({
      points: rightSig,
      stroke: colorRed,
      strokeWidth: 8,
      opacity: 1,
      tension: 0.3,
      lineCap: "round",
      x: this.stageWidth / 2,
    });

    // NormArea
    const leftNormAreaLine = new Konva.Line({
      points: leftNormArea,
      strokeWidth: 0,
      opacity: 0.7,
      tension: 0.3,
      closed: true,
      fill: "gainsboro",
      x: this.stageWidth / 2,
    });

    const rightNormAreaLine = new Konva.Line({
      points: rightNormArea,
      strokeWidth: 0,
      opacity: 0.7,
      tension: 0.3,
      closed: true,
      fill: "gainsboro",
      x: this.stageWidth / 2,
    });

    const lineGroup = new Konva.Group({
      x: 0,
    });

    lineGroup.add(leftNormAreaLine, rightNormAreaLine, leftHypoLine, rightHypoLine, leftNormLine, rightNormLine, leftMildLine, rightMildLine, leftModLine, rightModLine, leftSigLine, rightSigLine, leftLine, rightLine);
    this.data.add(lineGroup);

    if (this.showLegend) {
      this.renderLegend();
    }

    //const energyIndex = ScanViewUtils.calcEmgEnergyScore(this.scan);

    if (this.showDataValues) {
      this.renderEmgPatternData();
    }
  }

  // Renders EMG Pattern Data
  private renderEmgPatternData() {

    const energy = ScanViewUtils.calcEmgEnergyScore(this.scan).toFixed(1);

    const pattern = ScanViewUtils.calcEmgPatternScore(this.scan).toFixed(1);

    const symmetry = ScanViewUtils.calcEmgSymmetryScore(this.scan).toFixed(1);

    const bar1 = new Konva.Rect({
      x: 50,
      y: this.getSpinePositionFor(SpinalLocation.S1) + 275,
      width: (this.stageWidth - 200) / 3,
      height: 125,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bar2 = new Konva.Rect({
      x: bar1.x() + bar1.width() + 50,
      y: this.getSpinePositionFor(SpinalLocation.S1) + 275,
      width: (this.stageWidth - 200) / 3,
      height: 125,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bar3 = new Konva.Rect({
      x: bar2.x() + bar2.width() + 50,
      y: this.getSpinePositionFor(SpinalLocation.S1) + 275,
      width: (this.stageWidth - 200) / 3,
      height: 125,
      fill: "#f1f1f1",
      opacity: 0.7,
    });

    const bar1Text = new Konva.Text({
      x: bar1.x() + 150,
      y: bar1.y() + bar1.height() / 2,
      text: "Energy Index",
      fontSize: 42,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar1ValText = new Konva.Text({
      x: bar1Text.x() + bar1Text.width() + ((bar1.x() + bar1.width()) - (bar1Text.x() + bar1Text.width())) / 2,
      y: bar1.y() + bar1.height() / 2,
      text: energy,
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar2Text = new Konva.Text({
      x: bar2.x() + 150,
      y: bar2.y() + bar2.height() / 2,
      text: "Pattern",
      fontSize: 42,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar2ValText = new Konva.Text({
      x: bar2Text.x() + bar2Text.width() + ((bar2.x() + bar2.width()) - (bar2Text.x() + bar2Text.width())) / 2,
      y: bar2.y() + bar2.height() / 2,
      text: pattern + "%",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar3Text = new Konva.Text({
      x: bar3.x() + 150,
      y: bar3.y() + bar3.height() / 2,
      text: "Symmetry",
      fontSize: 42,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const bar3ValText = new Konva.Text({
      x: bar3Text.x() + bar3Text.width() + ((bar3.x() + bar3.width()) - (bar3Text.x() + bar3Text.width())) / 2,
      y: bar3.y() + bar3.height() / 2,
      text: symmetry + "%",
      fontSize: 48,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    const energyIcon = new Konva.Path({
      x: bar1.x() + 50,
      y: bar1.y() + 30,
      scaleX: 0.75,
      scaleY: 0.75,
      data: energySvgData,
      // offsetX: 296,
      // offsetY: 885,
      fill: "black",
    });

    const patternIcon = new Konva.Path({
      x: bar2.x() + 50,
      y: bar2.y() + 30,
      scaleX: 0.75,
      scaleY: 0.75,
      data: patternSvgData,
      offsetX: 296,
      offsetY: 885,
      fill: "black",
    });

    const symmetryIcon = new Konva.Path({
      x: bar3.x() + 50,
      y: bar3.y() + 30,
      scaleX: 0.75,
      scaleY: 0.75,
      data: symmetrySvgData,
      // offsetX: 296,
      // offsetY: 885,
      fill: "black",
    });

    bar1Text.offset({x: 0, y: bar1Text.getHeight() / 2});
    bar2Text.offset({x: 0, y: bar2Text.getHeight() / 2});
    bar3Text.offset({x: 0, y: bar3Text.getHeight() / 2});

    bar1ValText.offset({x: bar1ValText.getWidth() / 2, y: bar1ValText.getHeight() / 2});
    bar2ValText.offset({x: bar2ValText.getWidth() / 2, y: bar2ValText.getHeight() / 2});
    bar3ValText.offset({x: bar3ValText.getWidth() / 2, y: bar3ValText.getHeight() / 2});

    this.labels.add(bar1, bar2, bar3, bar1Text, bar2Text, bar3Text, bar1ValText, bar2ValText, bar3ValText, energyIcon, patternIcon, symmetryIcon);
  }

  // Renders EMG Amp data
  private renderEmgAmplitude() {

    const convertedScanData = this.scan.ScanData as Array<EMGScanData>;
    const leftMax = convertedScanData.sort((d1: EMGScanData, d2: EMGScanData) => d2.LeftValue.minus(d1.LeftValue).toNumber())[0].LeftValue;
    const rightMax = convertedScanData.sort((d1: EMGScanData, d2: EMGScanData) => d2.RightValue.minus(d1.RightValue).toNumber())[0].RightValue;
    const max = leftMax.greaterThan(rightMax) ? leftMax : rightMax;
    let autoScale = 25;
    if(max.lessThan(26)) {
      autoScale = 25;
    } else if (max.lessThan(51)) {
      autoScale = 50;
    } else if (max.lessThan(76)) {
      autoScale = 75;
    } else {
      autoScale = 100;
    }

    for (const scandata of this.scan.ScanData
      .filter((d: EMGScanData) => d.SpinalLocation != undefined)
      .sort((d1: EMGScanData, d2: EMGScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as EMGScanData;

      const leftValue = sd.LeftValue.negated();

      const leftColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, leftValue, autoScale);

      const rightValue = sd.RightValue;

      const rightColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, rightValue, autoScale);

      // Make text
      const text = new Konva.Text({
        x: this.stageWidth / 2,
        y: this.getSpinePositionFor(sd.SpinalLocation),
        text: SpinalLocation[sd.SpinalLocation],
        fontSize: 38,
        fontFamily: "Lato",
        fontStyle: "bold",
        fill: "#0f477a",
      });

      // Set offset for centering
      text.offsetX(text.getWidth() / 2);

      // Add to layer
      this.data.add(text);

      if (this.showDataValues) {
          this.renderBar(sd.SpinalLocation, leftValue, leftColors, 0.75, autoScale);
          this.renderBar(sd.SpinalLocation, rightValue, rightColors, 0.75, autoScale);
          this.renderValueText(sd.SpinalLocation, leftValue, 0.75);
          this.renderValueText(sd.SpinalLocation, rightValue, 0.75);
      } else {
          this.renderBar(sd.SpinalLocation, leftValue, leftColors, 0.75, autoScale);
          this.renderBar(sd.SpinalLocation, rightValue, rightColors, 0.75, autoScale);
      }
    }
    if (this.showLegend) {
      this.renderLegend();
    }
  }

  // Renders Live EMG Amp data
  private renderEmgAmplitudeLive() {

    // Live uses last value
    const sd = this.scanData.pop() as EMGScanData;
    this.emgPatternLiveStorage.push(sd);
    const leftValue = sd.LeftValue.negated();

    const leftColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, leftValue, this.emgEnhancedScaling);

    const rightValue = sd.RightValue;

    const rightColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, rightValue, this.emgEnhancedScaling);

    // Make text
    const text = new Konva.Text({
      x: this.stageWidth / 2,
      y: this.getSpinePositionFor(sd.SpinalLocation),
      text: SpinalLocation[sd.SpinalLocation],
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "#0f477a",
    });

    // Set offset for centering
    text.offsetX(text.getWidth() / 2);

    // Add to layer
    this.data.add(text);

    if (this.showDataValues) {
        this.renderBar(sd.SpinalLocation, leftValue, leftColors, 0.75, this.emgEnhancedScaling);
        this.renderBar(sd.SpinalLocation, rightValue, rightColors, 0.75, this.emgEnhancedScaling);
        this.renderValueText(sd.SpinalLocation, leftValue, 0.75);
        if(rightValue.greaterThan(0)) {
          this.renderValueText(sd.SpinalLocation, rightValue, 0.75);
        }
    } else {
        this.renderBar(sd.SpinalLocation, leftValue, leftColors, 0.75, this.emgEnhancedScaling);
        this.renderBar(sd.SpinalLocation, rightValue, rightColors, 0.75, this.emgEnhancedScaling);
    }
  }

  private reRenderEmgAmplitudeLive(scanData: Array<EMGScanData>) {
    for(let sd of scanData) {
      // Live uses last value
      const leftValue = sd.LeftValue.negated();

      const leftColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, leftValue, this.emgEnhancedScaling);

      const rightValue = sd.RightValue;

      const rightColors = ScanViewUtils.getEmgBarColor(sd.SpinalLocation, rightValue, this.emgEnhancedScaling);

      this.renderBar(sd.SpinalLocation, leftValue, leftColors, 0.75, this.emgEnhancedScaling);
      this.renderBar(sd.SpinalLocation, rightValue, rightColors, 0.75, this.emgEnhancedScaling);
    }
  }

  // Renders EMG Amp data
  private renderEmgAsymmetry() {

    for (const scandata of this.scan.ScanData
      .filter((d: EMGScanData) => d.SpinalLocation != undefined)
      .sort((d1: EMGScanData, d2: EMGScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as EMGScanData;

      const dif = sd.RightValue.minus(sd.LeftValue).dividedBy(Decimal.min(sd.LeftValue, sd.RightValue)).times(100).round();

      const difabs = dif.abs();

      const targetColorStops = ScanViewUtils.getEmgTriangleColor(difabs);

      // Make text
      const text = new Konva.Text({
        x: this.stageWidth / 2,
        y: this.getSpinePositionFor(sd.SpinalLocation),
        text: SpinalLocation[sd.SpinalLocation],
        fontSize: 38,
        fontFamily: "Lato",
        fontStyle: "bold",
        fill: "#0f477a",
      });

      // Set offset for centering
      text.offsetX(text.getWidth() / 2);

      // Add to layer
      this.data.add(text);

      if (this.showDataValues) {
          this.renderBar(sd.SpinalLocation, dif, targetColorStops, 0.75, 100, false);
          this.renderValueText(sd.SpinalLocation, dif, 0.75, 0, "%");
      } else {
          this.renderBar(sd.SpinalLocation, dif, targetColorStops, 0.75, 100, false);
      }
    }

    if (this.showLegend) {
      this.renderLegend();
    }
  }

  /// endregion

  /// region DTG

  // Draws the spinal text for spinal scan views
  private setupDtgText(cervical: boolean = false) {

    // For all spine locations
    for (const loc of this.getSpinePositions(cervical)) {

      if(cervical && loc.pos === 0) {
        const c0Text = new Konva.Text({
          x: this.stageWidth / 2,
          y: 200,
          text: 'C0',
          fontSize: 55,
          fontFamily: "Lato",
          fontStyle: 'normal',
          fill: "#0f477a",
        });
        // @ts-ignore
        c0Text.setOffset({
          x: c0Text.getWidth() / 2,
        });
        // Add to layer
        this.labels.add(c0Text);
      }

      if (loc.pos <= 24) {

        // Make text
        const text = new Konva.Text({
          x: this.stageWidth / 2,
          y: loc.y,
          text: loc.text,
          fontSize: cervical ? 55 : 38,
          fontFamily: "Lato",
          fontStyle: cervical ? "normal" : "bold",
          fill: "#0f477a",
        });

        // Set offset for centering
        // @ts-ignore
        text.setOffset({
          x: text.getWidth() / 2,
        });

        // Add to layer
        this.labels.add(text);
      }
    }
  }

  private renderDTGValueText(loc: SpinalLocation, value: Decimal, right: boolean, duration: number = 0.5, decimals: number = 1, suffix: string = "", cervical: boolean = false) {

    // Check left or right
    if (right) {

      // Make the text
      const text = new Konva.Text({
        y: this.getSpinePositionFor(loc, cervical) + spineHeight * (cervical ? .05 : .125),
        text: value.toFixed(decimals) + suffix,
        fontSize: cervical ? 55 : 38,
        fontFamily: "Lato",
        fontStyle: cervical ? "normal" : "bold",
        fill: "#5E6974",
      });

      // Set position
      text.x(this.stageWidth - text.width() - 50);

      // Add to layer
      this.data.add(text);

    } else {

      // Make the text
      const text = new Konva.Text({
        y: this.getSpinePositionFor(loc, cervical) + spineHeight * (cervical ? .05 : .125),
        text: value.toFixed(decimals) + suffix,
        fontSize: cervical ? 55 : 38,
        fontFamily: "Lato",
        fontStyle: cervical ? "normal" : "bold",
        fill: "#5E6974",
      });

      // Set position
      text.x(50);

      // Add to layer
      this.data.add(text);
    }
  }

  // Renders Dtg data
  private renderThermalDtgBars(cervical: boolean = false) {

    const dtgArea = this.getDtgBarArea(70, 150);

    // remove any rolling data and order by spinal position
    const data = this.scan.ScanData
      .filter((d: ThermalScanData) => d.SpinalLocation != undefined)
      .sort((d1: ThermalScanData, d2: ThermalScanData) => d1.SpinalLocation - d2.SpinalLocation) ;

    const thermalData = new List<ThermalScanData>(data as ThermalScanData[]);

    // Get first (lowest) readings
    const s1 = thermalData.Last();

    // Get range for left and right
    const maxLeft = thermalData.Max((d) => d.LeftValue.minus(s1.LeftValue).abs().toNumber());
    const maxRight = thermalData.Max((d) => d.RightValue.minus(s1.RightValue).abs().toNumber());

    const scaleLeft = (dtgArea.left.width / 2) / maxLeft * 0.9;
    const scaleRight = (dtgArea.right.width / 2) / maxRight * 0.9;

    for (const sd of data as ThermalScanData[]) {

      const difleft = sd.LeftValue.minus(s1.LeftValue);
      const difright = sd.RightValue.minus(s1.RightValue);

      let lx, rx, y, lwidth, rwidth, height;

      height = spineHeight * (cervical ? 1 : .75);
      y = this.getSpinePositionFor(sd.SpinalLocation, cervical) + spineHeight * (cervical ? .05 : .125);

      lx = dtgArea.left.x + dtgArea.left.width / 2;
      lwidth = Math.min(difleft.negated().toNumber() * scaleLeft, dtgArea.left.width);

      let colorLeft = difleft.greaterThan(0) ?  [0, colorRed, 1, colorRedEnd] : [0, colorBlue, 1, colorBlueEnd];

      // Make the bar
      const lbar = new Konva.Rect({
        x: lx,
        y,
        width: lwidth,
        height,
        fillLinearGradientStartPoint: { x : 0, y : -50},
        fillLinearGradientEndPoint: { x : 0, y : 50},
        fillLinearGradientColorStops: colorLeft,
        stroke: "black",
        strokeWidth: 1,
      });

      this.data.add(lbar);

      rx = dtgArea.right.x + dtgArea.right.width / 2;
      rwidth = Math.min(difright.toNumber() * scaleRight, dtgArea.right.width);

      let colorRight = difright.greaterThan(0) ?  [0, colorRed, 1, colorRedEnd] : [0, colorBlue, 1, colorBlueEnd];

      // Make the bar
      const rbar = new Konva.Rect({
        x: rx,
        y,
        width: rwidth,
        height,
        fillLinearGradientStartPoint: { x : 0, y : -50},
        fillLinearGradientEndPoint: { x : 0, y : 50},
        fillLinearGradientColorStops: colorRight,
        stroke: "black",
        strokeWidth: 1,
      });

      this.data.add(rbar);

      if (this.showDataValues) {
          this.renderDTGValueText(sd.SpinalLocation, difleft, false, 0.75, 1, "", cervical);
          this.renderDTGValueText(sd.SpinalLocation, difright, true, 0.75, 1, "", cervical);
      }
    }

    if (this.showLegend) {
      this.renderDTGLegend();
    }
  }

  private renderDTGLegend(duration: number = 0.25) {

    // Make the bar
    const legendBox = new Konva.Rect({
      // x: this.stageWidth - boxWidth - 50,
      y: 50,
      // width: boxWidth,
      height: 100,
      stroke: "black",
      strokeWidth: 1,
    });

    // Make the text
    const mildText = new Konva.Text({
      // x: legendBox.x() + 50,
      y: legendBox.y() + legendBox.height() / 2,
      text: "Cooler",
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: colorBlue,
    });

    // @ts-ignore
    mildText.setOffset({
      y: mildText.getHeight() / 2,
    });

    // Make the text
    const modText = new Konva.Text({
      // x: mildText.x() + mildText.width() + 50,
      y: legendBox.y() + legendBox.height() / 2,
      text: "Warmer",
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: colorRed,
    });

    // @ts-ignore
    modText.setOffset({
      y: modText.getHeight() / 2,
    });

    const boxWidth = 50 + mildText.width() + 50 + modText.width() + 50;

    // Resize box based on text sizes
    legendBox.x(this.stageWidth - boxWidth - 50);
    legendBox.width(boxWidth);

    mildText.x(legendBox.x() + 50);
    modText.x(mildText.x() + mildText.width() + 50);

    this.legend.add(legendBox);
    this.legend.add(mildText);
    this.legend.add(modText);
  }

  /// endregion

  /// region NCM

  // Draws the spinal text for spinal scan views
  private setupNcmText(cervical: boolean = false) {

    // For all spine locations
    for (const loc of this.getSpinePositions(cervical)) {

      if(cervical && loc.pos === 0) {
        const c0Text = new Konva.Text({
          x: this.stageWidth / 2,
          y: 200,
          text: 'C0',
          fontSize: 55,
          fontFamily: "Lato",
          fontStyle: 'normal',
          fill: "#0f477a",
        });
        // @ts-ignore
        c0Text.setOffset({
          x: c0Text.getWidth() / 2,
        });
        // Add to layer
        this.labels.add(c0Text);
      }

        if (loc.pos <= (cervical ? 8 : 24)) {

        // Make text
        const text = new Konva.Text({
          x: this.stageWidth / 2,
          y: loc.y,
          text: loc.text,
          fontSize: cervical ? 55 : 38,
          fontFamily: "Lato",
          fontStyle: cervical ? "normal" : "bold",
          fill: "#0f477a",
        });

        // Set offset for centering
        // @ts-ignore
        text.setOffset({
          x: text.getWidth() / 2,
        });

        // Add to layer
        this.labels.add(text);
      }
    }
  }

  private renderBar(loc: SpinalLocation, value: Decimal, color: any, duration: number = 0.5, barScale: number = 2, bar: boolean = true, cervical: boolean = false) {
    if (cervical && loc > 8) {
      return;
    }
    let x, y, width, height;

    height = spineHeight * (cervical ? 1 : .75);
    y = this.getSpinePositionFor(loc, cervical) + spineHeight * (cervical ? 0.05 : .125);

    if (value.greaterThan(0)) {

      x = this.stageWidth / 2 + 100;
      width = Math.min((value.toNumber() / barScale) * maxBarWidth, maxBarWidth);

    } else {

      x = this.stageWidth / 2 - 100;
      width = Math.max((-value / barScale) * -maxBarWidth, -maxBarWidth);

    }

    return bar ? this.renderBarRaw(x, y, width, height, value, color, duration) : this.renderTriangleRaw(x, y, width, height, value, color, duration);
  }

  private renderAlgoBar(loc: SpinalLocation, value: Decimal, color: any, position: number, duration: number = 0.5) {
    let x, y, width, height;

    height = spineHeight * .75;
    y = this.getSpinePositionFor(loc) + spineHeight * .125;

    x = 225;
    width = (this.stageHeight - x * 2) / 3;

    if (position == 2) {
      x = x + 25 + width;
    } else if (position == 3) {
      x = x + 50 + width * 2;
    }

    // Make the bar
    const bar = new Konva.Rect({
      x,
      y,
      width,
      height,
      fillLinearGradientStartPoint: { x : 0, y : -50},
      fillLinearGradientEndPoint: { x : 0, y : 50},
      fillLinearGradientColorStops: color,
      stroke: "black",
      strokeWidth: 1,
    });

    // Make text
    const text = new Konva.Text({
      x: x + width / 2,
      y,
      text: value.round().toString(),
      fontSize: 32,
      fontFamily: "Lato",
      fontStyle: "bold",
      fill: "black",
    });

    // Set offset for centering
    // @ts-ignore
    text.setOffset({
      x: text.getWidth() / 2,
    });

    // Add to layer
    this.data.add(bar, text);
  }

  public removeAllBars(){
    this.bars.left.forEach((l : Konva.Rect) => {l.destroy();})
    this.bars.right.forEach((r : Konva.Rect) => {r.destroy();})
    let children = this.data.getChildren((node) => node.getClassName() === 'Text' );
    for(let i = 0; i < children.length; i++){
      children[i].destroy();
    }
    this.bars.left = [];
    this.bars.right = [];
    this.data.draw();
  }

  public removeLastBars(isSingle: boolean = false, isThermal: boolean = false)
  {


    if(isSingle) {
      if(this.bars.left.length === this.bars.right.length) {
        this.emgPatternLiveStorage[this.emgPatternLiveStorage.length - 1].RightValue = new Decimal(0);
        let rightBar : Konva.Rect = this.bars.right.pop();
        rightBar.destroy();
        let children = this.data.getChildren((node) => node.getClassName() === 'Text' );
        if(children.length > 0) {
          children[children.length - 1].destroy();
        }
      } else {
        let leftBar : Konva.Rect = this.bars.left.pop();
        leftBar.destroy();
        let children = this.data.getChildren((node) => node.getClassName() === 'Text' );
        if(children.length > 2) {
          children[children.length - 1].destroy();
          children[children.length - 2].destroy();
        }
      }
    } else {
      if(isThermal) {
        if(this.bars.left.length === 0 && this.bars.right.length === 0) return;

        let maxLeft = this.bars.left.length > 0 ? this.bars.left[this.bars.left.length - 1].getAttr('y') : 20000;
        let maxRight = this.bars.right.length > 0 ? this.bars.right[this.bars.right.length - 1].getAttr('y') : 20000;

        if(maxLeft < maxRight) {
          let leftBar: Konva.Rect = this.bars.left.pop();
          leftBar.destroy();
        } else {
          let rightBar: Konva.Rect = this.bars.right.pop();
          rightBar.destroy();
        }
      } else {
        this.emgPatternLiveStorage.splice(this.emgPatternLiveStorage.length - 1, 1);
        let leftBar : Konva.Rect = this.bars.left.pop();
        let rightBar : Konva.Rect = this.bars.right.pop();
        leftBar.destroy();
        rightBar.destroy();
        let children = this.data.getChildren((node) => node.getClassName() === 'Text' );
        if(children.length > 2) {
          children[children.length - 1].destroy();
          children[children.length - 2].destroy();
          children[children.length - 3].destroy();
        }
      }
    }

    this.data.draw();
  }

  private renderBarRaw(x, y, width, height, value: Decimal, color: any, duration: number = 0.5) {

    // Make the bar
    const bar = new Konva.Rect({
      x,
      y,
      width,
      height,
      fillLinearGradientStartPoint: { x : 0, y : -50},
      fillLinearGradientEndPoint: { x : 0, y : 50},
      fillLinearGradientColorStops: color,
      stroke: "black",
      strokeWidth: 1,
    });
    this.data.add(bar);
    // Add to layer
    if(!value.equals(0)) {
      if(x > this.stageWidth / 2) {
        this.bars.right.push(bar);
      } else {
        this.bars.left.push(bar);
      }
    }
  }

  private renderTriangleRaw(x, y, width, height, value: Decimal, color: any, duration: number = 0.5) {

    // Points array
    const points = [x, y, x + width, y + height / 2, x, y + height];

    // Make the bar
    const traingle = new Konva.Line({
      points,
      fillLinearGradientStartPoint: { x : 0, y : -50},
      fillLinearGradientEndPoint: { x : 0, y : 50},
      fillLinearGradientColorStops: color,
      stroke: "black",
      strokeWidth: 1,
      closed: true,
    });

    // Add to layer
    this.data.add(traingle);

  }

  private renderCervicalTemp(loc: SpinalLocation, diff: Decimal, left: Decimal, right: Decimal) {
    if (loc > 8) {
      return;
    }

    const isGreater = diff.greaterThan(0);

    const offset = 15;

    // todo maybe add metric

    const leftTemp = `(${left.toFixed(1)}°)`;
    const rightTemp = `(${right.toFixed(1)}°)`;

    const rightText = new Konva.Text({
      y: this.getSpinePositionFor(loc, true) + spineHeight * .05 - (isGreater ? offset: -10),
      text: rightTemp,
      fontSize: 30,
      fontFamily: "Lato",
      fontStyle: 'normal',
      fill: "#5E6974",
    });

    // Set position
    rightText.x(this.stageWidth - rightText.width() - 50);

    // Add to layer
    this.data.add(rightText);

    // Make the text
    const leftText = new Konva.Text({
      y: this.getSpinePositionFor(loc, true) + spineHeight * .05 - (!isGreater ? offset: -10),
      text: leftTemp,
      fontSize: 30,
      fontFamily: "Lato",
      fontStyle: 'normal',
      fill: "#5E6974",
    });

    // Set position
    leftText.x(50);

    // Add to layer
    this.data.add(leftText);
  }

  private renderValueText(loc: SpinalLocation, value: Decimal, duration: number = 0.5, decimals: number = 1, suffix: string = "", cervical: boolean = false, offset: number = 0) {
   if (cervical && loc > 8) {
     return;
   }
    // Check left or right
    if (value.greaterThan(0)) {

      // Make the text
      const text = new Konva.Text({
        y: this.getSpinePositionFor(loc, cervical) + spineHeight * (cervical ? .05 : .125) + offset,
        text: value.toFixed(decimals) + suffix,
        fontSize: cervical ? 55 : 38,
        fontFamily: "Lato",
        fontStyle: cervical ? "normal" : "bold",
        fill: "#5E6974",
      });

      // Set position
      text.x(this.stageWidth - text.width() - 50);

      // Add to layer
      this.data.add(text);

    } else {

      // Make the text
      const text = new Konva.Text({
        y: this.getSpinePositionFor(loc, cervical) + spineHeight * (cervical ? .05 : .125) + offset,
        text: value.abs().toFixed(decimals) + suffix,
        fontSize: cervical ? 55 : 38,
        fontFamily: "Lato",
        fontStyle: cervical ? "normal" : "bold",
        fill: "#5E6974",
      });

      // Set position
      text.x(50);

      // Add to layer
      this.data.add(text);
    }
  }

  // Renders Ncm data
  private renderThermalNcm(cervical: boolean = false) {
    const renderTemp = this.scanViewType === ScanViewType.THERMAL_CERVICAL_NCM && cervical && this.scan.PatientId;
    const isNormativeCer = !this.scan.PatientId && cervical;
    if (isNormativeCer) {
      // left 0
      this.renderValueText(SpinalLocation.C4, new Decimal(0), 0.75, 1, "", true, 0);
      this.renderValueText(SpinalLocation.T1, new Decimal(0), 0.75, 1, "", true, 0);
      this.renderValueText(SpinalLocation.T2, new Decimal(0), 0.75, 1, "", true, 0);
      // right 0 it rounds down
      this.renderValueText(SpinalLocation.C4, new Decimal(0.01), 0.75, 1, "", true, 0);
      this.renderValueText(SpinalLocation.T1, new Decimal(0.01), 0.75, 1, "", true, 0);
      this.renderValueText(SpinalLocation.T2, new Decimal(0.01), 0.75, 1, "", true, 0);
    }
    for (const scandata of this.scan.ScanData
      .filter((d: ThermalScanData) => d.SpinalLocation != undefined)
      .sort((d1: ThermalScanData, d2: ThermalScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as ThermalScanData;

      let dif = sd.RightValue.minus(sd.LeftValue);

      if (this.showBias) {
        dif = dif.minus(this.scan.Bias);
      }

      const difabs = dif.abs();

      const targetColorStops = ScanViewUtils.getThermalBarColor(sd.SpinalLocation, difabs);

      if(cervical) {
        this.renderBar(sd.SpinalLocation, dif, targetColorStops, 0.75, 2, true, true);
        if(this.showDataValues) {
          this.renderValueText(sd.SpinalLocation, dif, 0.75, 1, "", true, renderTemp ? 15 : 0);
          if (renderTemp) {
            this.renderCervicalTemp(sd.SpinalLocation, dif, sd.LeftValue, sd.RightValue);
          }
        }
      } else {
        this.renderBar(sd.SpinalLocation, dif, targetColorStops, 0.75);
        if(this.showDataValues) {
          this.renderValueText(sd.SpinalLocation, dif, 0.75);
        }
      }
    }

    if (this.showLegend) {
      this.renderLegend();
    }

    if (this.showBias) {
      this.renderBias(this.scan.Bias);
    }
  }

  // Renders Ncm data
  private renderThermalNcmLive(cervical: boolean = false) {

    // Live uses last value
    const sd = this.scanData.pop() as ThermalScanData;

    // Checks for any erronious values
    if (sd.SpinalLocation != undefined) {

      const dif = sd.RightValue.minus(sd.LeftValue);

      const difabs = dif.abs();

      const targetColorStops = ScanViewUtils.getThermalBarColor(sd.SpinalLocation, difabs);

      if(cervical) {
        this.renderBar(sd.SpinalLocation, dif, targetColorStops, 1.75, 2, true, true);
        if(this.showDataValues) {
          this.renderValueText(sd.SpinalLocation, dif, 1.75, 1, "", true);
        }
      } else {
        this.renderBar(sd.SpinalLocation, dif, targetColorStops, 1.25);
        if(this.showDataValues) {
          this.renderValueText(sd.SpinalLocation, dif, 1.25);
        }
      }
    }

  }

  /// endregion

  /// region LINE

  // Draws the text for thermal line graphs
  private setupThermalLineText(cervical: boolean = false) {

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    // Border
    const border = new Konva.Rect({
      width,
      height,
      x,
      y,
      stroke: "black",
      strokeWidth: 1,
    });

    this.labels.add(border);

    // Vertical line
    const vline = new Konva.Line({
      points: [x + width / 2, y, x + width / 2, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.75,
    });

    this.labels.add(vline);

    // Value lines
    const markSpace = width / 6; // Make marks at every 2 degrees

    const mark1 = new Konva.Line({
      points: [x + markSpace, y, x + markSpace, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
    });

    const mark2 = new Konva.Line({
      points: [x + markSpace * 2, y, x + markSpace * 2, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
    });

    const mark3 = new Konva.Line({
      points: [x + markSpace * 4, y, x + markSpace * 4, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
    });

    const mark4 = new Konva.Line({
      points: [x + markSpace * 5, y, x + markSpace * 5, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
    });

    this.labels.add(mark1, mark2, mark3, mark4);

    const t1line = this.getSpinePositionFor(SpinalLocation.T1, cervical);
    const l1line = this.getSpinePositionFor(SpinalLocation.L1, cervical);

    // Horizontal Lines
    const hmark1 = new Konva.Line({
      points: [x, t1line, x + width, t1line],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
      id: "t1line",
    });

    // Horizontal Lines
    const hmark2 = new Konva.Line({
      points: [x, l1line, x + width, l1line],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.4,
      id: "l1line",
    });

    cervical ? this.labels.add(hmark1) : this.labels.add(hmark1, hmark2);

    const labelY = y + height + 15;

    // Labels
    // Make text
    const vtext = new Konva.Text({
      x: x + markSpace * 3,
      y: labelY,
      text: "0",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text0 = new Konva.Text({
      x,
      y: labelY,
      text: "6",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text1 = new Konva.Text({
      x: x + markSpace,
      y: labelY,
      text: "4",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text2 = new Konva.Text({
      x: x + markSpace * 2,
      y: labelY,
      text: "2",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text4 = new Konva.Text({
      x: x + markSpace * 4,
      y: labelY,
      text: "2",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text5 = new Konva.Text({
      x: x + markSpace * 5,
      y: labelY,
      text: "4",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const text6 = new Konva.Text({
      x: x + markSpace * 6,
      y: labelY,
      text: "6",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    // Set offset for centering
    vtext.offsetX(vtext.getWidth() / 2);
    text0.offsetX(text0.getWidth() / 2);
    text1.offsetX(text1.getWidth() / 2);
    text2.offsetX(text2.getWidth() / 2);
    text4.offsetX(text4.getWidth() / 2);
    text5.offsetX(text5.getWidth() / 2);
    text6.offsetX(text6.getWidth() / 2);

    this.labels.add(vtext, text0, text1, text2, text4, text5, text6);

    // TODO: Horizontal Labels + T1/L1 markers and scaling
    const leftText1 = new Konva.Text({
      x: x - 15,
      y: y + height,
      text: cervical ? "T2" : "S1",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
      id: "s1text"
    });

    const leftText2 = new Konva.Text({
      x: x - 15,
      y,
      text: "C2",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
    });

    const leftText3 = new Konva.Text({
      x: x - 15,
      y: t1line,
      text: "T1",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
      id: "t1text",
    });

    const leftText4 = new Konva.Text({
      x: x - 15,
      y: l1line,
      text: "L1",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "black",
      id: "l1text",
    });

    leftText1.offset({
      x: leftText1.getWidth(),
      y: leftText1.getHeight() / 2,
    });

    leftText2.offset({
      x: leftText1.getWidth(),
      y: leftText1.getHeight() / 2,
    });

    leftText3.offset({
      x: leftText1.getWidth(),
      y: leftText1.getHeight() / 2,
    });

    leftText4.offset({
      x: leftText1.getWidth(),
      y: leftText1.getHeight() / 2,
    });

    cervical ? this.labels.add(leftText1, leftText2, leftText3) : this.labels.add(leftText1, leftText2, leftText3, leftText4);
  }

  // Renders a partial thermal line
  private renderThermalLineLive() {
    const rollingdata = this.scanData.filter((d: ThermalRollingData) => d.LeftReadings)[0] as ThermalRollingData;

    // This is the area we can draw in
    const {x, y, width, height} = this.getThermalLineArea();

    // This is the scaling for diff (left vs right)
    const xScale = width / 12;

    // Find our drawing locations for l1 / t1
    const l1pos = this.getSpinePositionFor(SpinalLocation.L1) - y;
    const t1pos = this.getSpinePositionFor(SpinalLocation.T1) - y;

    // Find all the markers we have
    let markersInData = rollingdata.EventMarkers.filter(e => e !== 0).map(e => e - 1);

    // Get the first marker and update it based on the first event marker
    if (markersInData.length > 0) {
      const s1Text = this.labels.findOne("#s1text") as Konva.Text;

      if (s1Text) {
        // Set the first marker text to be the first marker in the array
        // Gives us the text for the user selected "starting position"
        s1Text.text(SpinalLocation[markersInData[0]]);
      }
    }

    // We set these to 99 so if they have not been hit yet, they wont be used
    let l1index = -1, t1index = -1, c2index = -1;
    let distOffset = 0;

    // Find the index of L1 / T1
    rollingdata.EventMarkers.filter((e, i) => {
      if (markersInData.length > 0 && e == markersInData[0] + 1) {
        // If the index is zero, that becomes our starter
        distOffset = rollingdata.DistanceReadings[i].toNumber();
      } else if (e == SpinalLocation.L1 + 1) {
        l1index = i;
        distOffset = rollingdata.DistanceReadings[i].toNumber();
      } else if (e == SpinalLocation.T1 + 1) {
        t1index = i;
        distOffset = rollingdata.DistanceReadings[i].toNumber();
      } else if (e == SpinalLocation.C2 + 1) {
        c2index = i;
        distOffset = rollingdata.DistanceReadings[i].toNumber();
      }
    });


    // Hide lines and labels if we have not recorded them yet

    // Gets the node for line and text objects
    const l1Text = this.labels.findOne("#l1text");
    const l1Line = this.labels.findOne("#l1line");

    const t1Text = this.labels.findOne("#t1text");
    const t1Line = this.labels.findOne("#t1line");

    if (l1Text && l1Line && t1Text && t1Line) {

      // We will only use this if the l1 marker exists and is not the first marker
      if (l1index <= 0) {
        l1Text.hide();
        l1Line.hide();
      } else {
        l1Text.show();
        l1Line.show();
      }

      if (t1index <= 0) {
        t1Text.hide();
        t1Line.hide();
      } else {
        t1Text.show();
        t1Line.show();
      }

      this.labels.draw();

    }

    // If l1 has not been found yet, we assume max is 28
    // TODO: get the proper max from david
    const posScale = height / 28;

    const s1l1Scale = (height - l1pos) / l1index;
    // let s1l1Scale = (height - l1pos) / l1dist;
    const l1t1Scale = (l1pos - t1pos) / (t1index - l1index);
    const t1c2Scale = t1pos / (c2index - t1index);

    // Special scales
    const s1t1Scale = (height - t1pos) / t1index;
    const s1c2Scale = height / c2index;

    const pointArray = [0, 0];

    const maxIndex = c2index == -1 ? rollingdata.LeftReadings.length : c2index;

    // Create lines
    for (let i = 0; i < maxIndex; i++) {

      const dif = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);
      const dist = rollingdata.DistanceReadings[i].minus(distOffset).toNumber();

      // No bias on running scan
      pointArray.push(dif.toNumber() * xScale);

      if (i < l1index) {
        // S1 to L1
        pointArray.push(i * s1l1Scale * -1);
        //
      } else if (i < t1index) {
        // L1 to T1
        if (l1index > 0) {
          pointArray.push((height - l1pos + ((i - l1index) * l1t1Scale)) * -1);
        } else {
          pointArray.push(i * s1t1Scale * -1);
        }
      } else if (i < c2index) {
        // T1 to C2
        if (t1index > 0) {
          pointArray.push((height - t1pos + ((i - t1index) * t1c2Scale)) * -1);
        } else {
          pointArray.push(i * s1c2Scale * -1);
        }
      } else {
        if (t1index > 0) {
          pointArray.push((height - t1pos + dist * posScale) * -1);
        } else if (l1index > 0) {
          pointArray.push((height - l1pos + dist * posScale) * -1);
        } else {
          pointArray.push(dist * posScale * -1);
        }
      }
    }

    const sd = this.scanData.filter((d: ThermalScanData) => d.SpinalLocation == SpinalLocation.C1)[0] as ThermalScanData;

    if (sd != undefined) {
      this.renderThermalPin(sd);
    }

    if (!this.thermalLine) {
      this.thermalLine = new Konva.Line({
        points: pointArray,
        stroke: "green",
        strokeWidth: 2,
      });

      this.thermalLine.move({
        x: this.stageWidth / 2,
        y: y + height - 1, // Offset by one to make sure we don't draw onto the border lines
      });

      this.data.add(this.thermalLine);
    } else {
      this.thermalLine.points(pointArray);
      this.data.draw();
    }
  }

  // Renders line data
  private renderThermalLine(duration: number = 1, cervical: boolean = false) {

    const rollingdata = this.scan.ScanData.filter((d: ThermalRollingData) => d.LeftReadings)[0] as ThermalRollingData;

    if (!rollingdata) {
      return;
    }

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    const xScale = width / 12;

    const l1pos = this.getSpinePositionFor(SpinalLocation.L1, cervical) - y;
    const t1pos = this.getSpinePositionFor(SpinalLocation.T1, cervical) - y;

    let l1index = -1, t1index = -1;

    // Find all the markers we have
    let markersInData = rollingdata.EventMarkers.filter(e => e !== 0).map(e => e - 1);

    // Find the index of L1. Lisa is indexed at 1, not 0
    rollingdata.EventMarkers.filter((e, i) => {
      if (e == SpinalLocation.L1 + 1) {
        l1index = i;
      } else if (e == SpinalLocation.T1 + 1) {
        t1index = i;
           }
    });

    // Get the starting pos for the first reading
    let startingPos = this.getSpinePositionFor(markersInData[0], cervical) - y;

    const s1l1Scale = (startingPos - l1pos) / l1index;
    const l1t1Scale = (l1pos - t1pos) / (t1index - l1index);
    const t1c2Scale = t1pos / (rollingdata.EventMarkers.length - t1index);

    // Special scales
    const s1t1Scale = (startingPos - t1pos) / t1index;
    const s1c2Scale = startingPos / rollingdata.EventMarkers.length;

    const pointArray = [];

    // Skip C1, we will use segmental data for that
    for (let i = 0; i < rollingdata.LeftReadings.length; i++) {

      let dif = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

      if (this.showBias) {
        dif = dif.minus(this.scan.Bias);
      }

      pointArray.push(dif.toNumber() * xScale);

      if (i < l1index) {
        // S1 to L1
        pointArray.push(i * s1l1Scale * -1);
      } else if (i < t1index) {
        // L1 to T1
        if (l1index >= 0) {
          pointArray.push((height - l1pos + ((i - l1index) * l1t1Scale)) * -1);
        } else {
          pointArray.push((height - startingPos + (i * s1t1Scale)) * -1);
        }
      } else {
        // T1 to C2
        if (t1index >= 0) {
          pointArray.push((height - t1pos + ((i - t1index) * t1c2Scale)) * -1);
        } else {
          pointArray.push((height - startingPos + (i * s1c2Scale)) * -1);
        }
      }
    }

    const lineGroup = new Konva.Group({
      // clipX: 0,
      // clipY: 0,
      // clipWidth: this.stageWidth,
      // clipHeight: this.stageHeight,
    });

    const line = new Konva.Line({
      points: pointArray,
      stroke: "green",
      strokeWidth: 2,
    });

    line.move({
      x: this.stageWidth / 2,
      y: y + height - 1, // Offset by one to make sure we don't draw onto the border lines
    });

    lineGroup.add(line);
    this.data.add(lineGroup);

    // Gets the time at which L1 will be revealed in our animation
    const l1Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.L1) - y) / this.stageHeight) * duration;

    // Gets the time at which T1 will be revealed in our animation
    const t1Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.T1) - y) / this.stageHeight) * duration;

    // Gets the node for line and text objects
    const l1Text = this.labels.findOne("#l1text");
    const l1Line = this.labels.findOne("#l1line");

    const t1Text = this.labels.findOne("#t1text");
    const t1Line = this.labels.findOne("#t1line");

    this.renderThermalPin(undefined, cervical);

    if (this.showBias) {
      this.renderBias(this.scan.Bias);
    }
  }

  // Renders the C1 Pin at the top of the thermal
  private renderThermalPin(sd = undefined, cervical: boolean = false) {

    if (sd == undefined) {
      sd = this.scan.ScanData.filter((d: ThermalScanData) => d.SpinalLocation == SpinalLocation.C1)[0] as ThermalScanData;
    }

    const bias = this.scan ? this.scan.Bias : 0;

    const dif = sd.RightValue.minus(sd.LeftValue).minus(bias);

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    const xPos = ((width / 12) * dif.toNumber()) + width / 2;

    const pin = new Konva.Path({
      x: x + xPos,
      y,
      data: ScanViewUtils.pinPathCubicBezier(75, 115),
      fill: "white",
      stroke: "green",
      strokeWidth: 2,
    });

    // Make text
    const pinText = new Konva.Text({
      x: x + xPos,
      y: y - 75,
      text: "C1",
      fontSize: 34,
      fontFamily: "Lato",
      fill: "green",
    });

    pinText.offset({
      x: pinText.width() / 2,
      y: pinText.height() / 2,
    });

    this.data.add(pin, pinText);
  }

  /// endregion

  /// region SUMMARY

  // Draws the text for thermal line graphs
  private setupThermalSummaryText(cervical: boolean = false) {
    // HERE WORK

    const rollingdata = this.scan.ScanData.filter((d: ThermalRollingData) => d.LeftReadings)[0] as ThermalRollingData;

    if (!rollingdata) {
      return;
    }

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    const max = this.calculateRollingScale();

    let iScale;

    for (iScale = 2; iScale <= 8; iScale += 2) {
      if (iScale > max) break;
    }

    // Vertical line
    const vline = new Konva.Line({
      points: [x + width / 2, y, x + width / 2, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 1,
      dash: [5, 20],
    });

    this.labels.add(vline);

    // Horizontal Line
    const hline = new Konva.Line({
      points: [x, y + height, x + width, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.75,
    });

    this.labels.add(hline);

    // Value lines
    const markSpace = width / 4; // Make marks at every 2 degrees

    const mark0 = new Konva.Line({
      points: [x, y, x, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 1,
      dash: [5, 20],
    });

    const mark1 = new Konva.Line({
      points: [x + markSpace, y, x + markSpace, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 1,
      dash: [5, 20],
    });

    const mark2 = new Konva.Line({
      points: [x + markSpace * 3, y, x + markSpace * 3, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 1,
      dash: [5, 20],
    });

    const mark3 = new Konva.Line({
      points: [x + width, y, x + width, y + height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 1,
      dash: [5, 20],
    });

    this.labels.add(mark0, mark1, mark2, mark3);

    const labelY = y + height + (cervical ? 15 : 35);

    // Labels
    // Make text
    const vtext = new Konva.Text({
      x: x + markSpace * 2,
      y: labelY,
      text: "0",
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: cervical ? "normal" : "bold",
      fill: "black",
      shadowColor: "white",
      shadowBlur: 0,
      shadowOffset: {
        x: 2,
        y: 2,
      },
      shadowOpacity: 0.7,
    });

    const text0 = new Konva.Text({
      x,
      y: labelY,
      //text: "-" + iScale,
      text: iScale,
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: cervical ? "normal" : "bold",
      fill: "black",
      shadowColor: "white",
      shadowBlur: 0,
      shadowOffset: {
        x: 2,
        y: 2,
      },
      shadowOpacity: 0.7,
    });

    const text1 = new Konva.Text({
      x: x + markSpace,
      y: labelY,
      //text: "-" + iScale / 2,
      text: (iScale / 2).toFixed(0),
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: cervical ? "normal" : "bold",
      fill: "black",
      shadowColor: "white",
      shadowBlur: 0,
      shadowOffset: {
        x: 2,
        y: 2,
      },
      shadowOpacity: 0.7,
    });

    const text2 = new Konva.Text({
      x: x + markSpace * 3,
      y: labelY,
      text: (iScale / 2).toFixed(0),
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: cervical ? "normal" : "bold",
      fill: "black",
      shadowColor: "white",
      shadowBlur: 0,
      shadowOffset: {
        x: 2,
        y: 2,
      },
      shadowOpacity: 0.7,
    });

    const text3 = new Konva.Text({
      x: x + width,
      y: labelY,
      text: iScale.toFixed(0),
      fontSize: 38,
      fontFamily: "Lato",
      fontStyle: cervical ? "normal" : "bold",
      fill: "black",
      shadowColor: "white",
      shadowBlur: 0,
      shadowOffset: {
        x: 2,
        y: 2,
      },
      shadowOpacity: 0.7,
    });

    // Set offset for centering
    vtext.offsetX(vtext.getWidth() / 2);
    text0.offsetX(text1.getWidth() / 2);
    text1.offsetX(text1.getWidth() / 2);
    text2.offsetX(text2.getWidth() / 2);
    text3.offsetX(text2.getWidth() / 2);

    this.labels.add(vtext, text0, text1, text2, text3);
  }

  private setupThermalDtgText(cervical?: boolean) {
    const dtgArea = this.getDtgArea(cervical);

    // Vertical line left
    const leftline = new Konva.Line({
      points: [dtgArea.left.x + dtgArea.left.width / 2, dtgArea.left.y, dtgArea.left.x + dtgArea.left.width / 2, dtgArea.left.y + dtgArea.left.height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.75,
    });

    // Vertical line right
    const rightline = new Konva.Line({
      points: [dtgArea.right.x + dtgArea.right.width / 2, dtgArea.right.y, dtgArea.right.x + dtgArea.right.width / 2, dtgArea.right.y + dtgArea.right.height],
      stroke: "black",
      strokeWidth: 1,
      opacity: 0.75,
    });

    this.labels.add(leftline, rightline);
  }

  // Renders thermal dtg graphs
  private renderThermalDtg(cervical: boolean = false) {

    const dtgArea = this.getDtgArea(cervical);

    // remove any rolling data and order by spinal position
    const data = this.scan.ScanData
      .filter((d: ThermalScanData) => d.SpinalLocation != undefined)
      .sort((d1: ThermalScanData, d2: ThermalScanData) => d1.SpinalLocation - d2.SpinalLocation) ;

    const thermalData = new List<ThermalScanData>(data as ThermalScanData[]);

    // Get first (lowest) readings
    const s1 = thermalData.Last();
    delay(100);
    // Get range for left and right
    const maxLeft = thermalData.Max((d) => d.LeftValue.minus(s1.LeftValue).abs().toNumber());
    const maxRight = thermalData.Max((d) => d.RightValue.minus(s1.RightValue).abs().toNumber());

    const scaleLeft = (dtgArea.left.width / 2) / maxLeft * 0.9;
    const scaleRight = (dtgArea.right.width / 2) / maxRight * 0.9;
    //const scaleY = dtgArea.left.height / (thermalData.Count() - 1);
    const scaleY = (this.getSpinePositionFor(s1.SpinalLocation, cervical) - dtgArea.left.y) / (thermalData.Count() - 1);

    const pointArrayLeft = [];
    const pointArrayRight = [];

    let i = 0;

    for (const scandata of data as ThermalScanData[]) {
      const difleft = scandata.LeftValue.minus(s1.LeftValue).negated();
      const difright = scandata.RightValue.minus(s1.RightValue);

      pointArrayLeft.push(difleft.toNumber() * scaleLeft);
      pointArrayLeft.push(i * scaleY);

      pointArrayRight.push(difright.toNumber() * scaleRight);
      pointArrayRight.push(i * scaleY);

      i++;
    }

    // Line coloring
    const leftred = new Konva.Rect({
      x: dtgArea.left.x,
      y: dtgArea.left.y,
      width: dtgArea.left.width / 2,
      height: dtgArea.left.height,
      fill: "red",
    });

    const leftblue = new Konva.Rect({
      x: dtgArea.left.x + dtgArea.left.width / 2,
      y: dtgArea.left.y,
      width: dtgArea.left.width / 2,
      height: dtgArea.left.height,
      fill: "blue",
    });

    const rightblue = new Konva.Rect({
      x: dtgArea.right.x,
      y: dtgArea.right.y,
      width: dtgArea.right.width / 2,
      height: dtgArea.right.height,
      fill: "blue",
    });

    const rightred = new Konva.Rect({
      x: dtgArea.right.x + dtgArea.right.width / 2,
      y: dtgArea.right.y,
      width: dtgArea.right.width / 2,
      height: dtgArea.right.height,
      fill: "red",
    });

    // Lines

    const lineleft = new Konva.Line({
      points: pointArrayLeft,
      stroke: "black",
      strokeWidth: 4,
      tension: 0.3,
      globalCompositeOperation: "destination-in",
    });

    const lineright = new Konva.Line({
      points: pointArrayRight,
      stroke: "black",
      strokeWidth: 4,
      tension: 0.3,
      globalCompositeOperation: "destination-in",
    });

    lineleft.move({
      x: dtgArea.left.x + dtgArea.left.width / 2,
      y: dtgArea.left.y, // Offset by one to make sure we don't draw onto the border lines
    });

    lineright.move({
      x: dtgArea.right.x + dtgArea.right.width / 2,
      y: dtgArea.right.y, // Offset by one to make sure we don't draw onto the border lines
    });

    this.lineGroupLeft = new Konva.Layer({
      // clipX: 0,
      // clipY: 0,
      // clipWidth: this.stageWidth,
      // clipHeight: this.stageHeight,
    });

    this.lineGroupRight = new Konva.Layer({
      // clipX: 0,
      // clipY: 0,
      // clipWidth: this.stageWidth,
      // clipHeight: this.stageHeight,
    });

    this.lineGroupLeft.add(leftred, leftblue);
    this.lineGroupLeft.add(lineleft);

    this.lineGroupRight.add(rightred, rightblue);
    this.lineGroupRight.add(lineright);

    this.stage.add(this.lineGroupLeft);
    this.stage.add(this.lineGroupRight);
  }

  private calculateRollingScale(): number {

    const rollingdata = this.scan.ScanData.filter((d: ThermalRollingData) => d.LeftReadings)[0] as ThermalRollingData;
    const segmentData = this.scan.ScanData.filter((d: ThermalScanData) => d.SpinalLocation != undefined);

    if (!rollingdata) {
      return;
    }

    let max = 0;

    for (const scandata of segmentData as ThermalScanData[]) {
      let diff = scandata.RightValue.minus(scandata.LeftValue);
      if (this.showBias) {
        diff = diff.minus(this.scan.Bias);
      }
      const difabs = diff.abs().toNumber();
      max = Math.max(max, difabs);

    }
    return max;
  }

  // Renders summary data
  private renderThermalSummary(cervical: boolean = false) {

    const duration = 1;
    const rollingdata = this.scan.ScanData.filter((d: ThermalRollingData) => d.LeftReadings)[0] as ThermalRollingData;

    if (!rollingdata) {
      return;
    }

    const {x, y, width, height} = this.getThermalLineArea(cervical);

    const max = this.calculateRollingScale();

    let iScale;

    for (iScale = 2; iScale <= 8; iScale += 2) {
      if (iScale > max) break;
    }

    const xScale = width / (iScale * 2);

    // Find all the markers we have
    let markersInData = rollingdata.EventMarkers.filter(e => e !== 0).map(e => e - 1);


    // Get the starting pos for the first reading
    let startingPos = (this.getSpinePositionFor(markersInData[0], cervical) - y) + (spineHeight / 2);

    const l1pos = this.getSpinePositionFor(SpinalLocation.L1, cervical) - y;
    const t1pos = this.getSpinePositionFor(SpinalLocation.T1, cervical) - y;

    let l1index = -1, t1index = -1, t2index = -1;

    let s1val = 0, l1val = 0, t1val = 0, c2val = 0, t2val = 0;

    // Find the index of L1. Lisa is indexed at 1, not 0
    rollingdata.EventMarkers.filter((e, i) => {

      let v;

      switch (e) {
        case SpinalLocation.S1 + 1:
          v = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

          if (this.showBias) {
            v = v.minus(this.scan.Bias);
          }

          s1val = v.toNumber();
          break;

        case SpinalLocation.L1 + 1:
          l1index = i;
          v  = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

          if (this.showBias) {
            v = v.minus(this.scan.Bias);
          }

          l1val = v.toNumber();
          break;

        case SpinalLocation.T1 + 1:
          t1index = i;
          v = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

          if (this.showBias) {
            v = v.minus(this.scan.Bias);
          }

          t1val = v.toNumber();
          break;

        case SpinalLocation.T2 + 1:
          t2index = i;
          v = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

          if (this.showBias) {
            v = v.minus(this.scan.Bias);
          }

          t2val = v.toNumber();
          break;

        case SpinalLocation.C2 + 1:
          v = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

          if (this.showBias) {
            v = v.minus(this.scan.Bias);
          }

          c2val = v.toNumber();
          break;
      }

    });

    const s1l1Scale = (height - l1pos) / l1index;
    const l1t1Scale = (l1pos - t1pos) / (t1index - l1index);
    const t1c2Scale = t1pos / (rollingdata.EventMarkers.length - t1index);

    // Special scales
    const s1t1Scale = (startingPos - t1pos) / t1index;
    const s1c2Scale = startingPos / rollingdata.EventMarkers.length;

    const pointArray = [];
    const barArray = [];

    pointArray.push(0, (height - startingPos) * -1);

    let difFirst = rollingdata.RightReadings[0].minus(rollingdata.LeftReadings[0]);

    if (this.showBias) {
      difFirst = difFirst.minus(this.scan.Bias);
    }

    difFirst = difFirst.abs();

    // determine the first readings color
    let color = ScanViewUtils.getThermalBarColorSingle(SpinalLocation.L5, difFirst);

    let barY = y + height;

    // Skip C1, we will use segmental data for that
    for (let i = 0; i < rollingdata.LeftReadings.length; i++) {

      let dif = rollingdata.RightReadings[i].minus(rollingdata.LeftReadings[i]);

      if (this.showBias) {
        dif = dif.minus(this.scan.Bias);
      }

      const difabs = dif.abs();

      let targetColor;

      // Clamp value between min and max of scaling
      dif = Decimal.min(Decimal.max(dif, -iScale), iScale);

      pointArray.push(dif.toNumber() * xScale);

      let ypos;

      if (i < l1index) {
        // S1 to L1
        ypos = (height - startingPos + (i * s1l1Scale)) * -1;

        targetColor = ScanViewUtils.getThermalBarColorSingle(SpinalLocation.L5, difabs);
      } else if (i < t1index) {
        // L1 to T1
        ypos = (height - l1pos + ((i - l1index) * l1t1Scale)) * -1;

        if (l1index >= 0) {
          ypos = (height - l1pos + ((i - l1index) * l1t1Scale)) * -1;
        } else {
          ypos = (height - startingPos + (i * s1t1Scale)) * -1;
        }

        targetColor = ScanViewUtils.getThermalBarColorSingle(SpinalLocation.T12, difabs);
      } else {
        // T1 to C2
        if (t1index >= 0) {
          ypos = (height - t1pos + ((i - t1index) * t1c2Scale)) * -1;
        } else {
          ypos = (height - startingPos + (i * s1c2Scale)) * -1;
        }

        targetColor = ScanViewUtils.getThermalBarColorSingle(SpinalLocation.C7, difabs);
      }

      pointArray.push(ypos);

      // Check if we need to make a rect
      if (targetColor != color) {
        // Color has changed, time to make a new box!

        // Finish the old one
        const bar = new Konva.Rect({
          x,
          y: barY,
          width,
          height: ypos + (height + y - barY),
          fillLinearGradientStartPoint: { x : 0, y : 0},
          fillLinearGradientEndPoint: { x : width, y : 0},
          fillLinearGradientColorStops: [0, "Black", 0.5, color, 1, "Black"],
        });

        barArray.push(bar);

        color = targetColor;

        barY = y + height + ypos;
      }
    }

    // Finish last rect
    const lastbar = new Konva.Rect({
      x,
      y: barY,
      width,
      height: y - barY,
      fillLinearGradientStartPoint: { x : 0, y : 0},
      fillLinearGradientEndPoint: { x : width, y : 0},
      fillLinearGradientColorStops: [0, "Black", 0.5, color, 1, "Black"],
    });

    barArray.push(lastbar);


    const lineGroup = new Konva.Group({
      // clipX: 0,
      // clipY: 0,
      // clipWidth: this.stageWidth,
      // clipHeight: this.stageHeight,
    });

    const lineMask = new Konva.Line({
      points: pointArray,
      // stroke: 'black',
      // strokeWidth: 2,
      fill: "red",
      closed: true,
      globalCompositeOperation: "destination-in",
    });

    lineMask.move({
      x: this.stageWidth / 2,
      y: y + height - 1, // Offset by one to make sure we don't draw onto the border lines
    });

    for (const b of barArray) {
      lineGroup.add(b);
    }

    lineGroup.add(lineMask);

    // Remove last connector from array
    pointArray.pop();
    pointArray.pop();
    pointArray.pop();
    pointArray.pop();

    pointArray.push(0, -height + 10);
    pointArray.push(0, 0);
    const line = new Konva.Line({
      points: pointArray,
      stroke: "black",
      strokeWidth: 2,
    });

    line.move({
      x: this.stageWidth / 2,
      y: y + height - 1, // Offset by one to make sure we don't draw onto the border lines
    });

    lineGroup.add(line);

    this.data.add(lineGroup);

    // Do the C1 Bar
    const sd = this.scan.ScanData.filter((d: ThermalScanData) => d.SpinalLocation == SpinalLocation.C1)[0] as ThermalScanData;

    let dif = sd.RightValue.minus(sd.LeftValue);

    if (this.showBias) {
      dif = dif.minus(this.scan.Bias);
    }

    const difabs = dif.abs();

    const colorStops = [0, ScanViewUtils.getThermalBarColorSingle(SpinalLocation.C1, difabs), 1, "Black"];
    let colorEndpoint;

    let c1x, c1y, c1width, c1height;

    c1height = spineHeight * (cervical ? 1 : .75);
    c1y = this.getSpinePositionFor(SpinalLocation.C1, cervical) + spineHeight * (cervical ? .05 : .125);
    c1x = this.stageWidth / 2;

    if (dif.greaterThan(0)) {
      c1width = Math.min(dif.toNumber() * xScale, xScale * 2);
      colorEndpoint = { x : xScale * 2, y : 0};
    } else {
      c1width = Math.max(dif.toNumber() * xScale, -xScale * 2);
      colorEndpoint = { x : xScale * -2, y : 0};
    }

    // Make the bar
    const bar = new Konva.Rect({
      x: c1x,
      y: c1y,
      width: c1width,
      height: c1height,
      fillLinearGradientStartPoint: { x : 0, y : 0},
      fillLinearGradientEndPoint: colorEndpoint,
      fillLinearGradientColorStops: colorStops,
      stroke: "black",
      strokeWidth: 1,
    });

    // Add to layer
    lineGroup.add(bar);

    // // Gets the time at which S1 will be revealed in our animation
    const s1Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.S1) - y) / this.stageHeight) * duration;

    // // Gets the time at which L1 will be revealed in our animation
    const l1Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.L1) - y) / this.stageHeight) * duration;

    // // Gets the time at which T1 will be revealed in our animation
    const t1Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.T1) - y) / this.stageHeight) * duration;

    // // Gets the time at which C2 will be revealed in our animation
    const c2Time = ((this.stageHeight - this.getSpinePositionFor(SpinalLocation.C2) - y) / this.stageHeight) * duration;

    const s1pin = this.renderThermalSummaryPin(SpinalLocation.S1, s1val < 0 ? "right" : "left", 0, cervical);
    const l1pin = this.renderThermalSummaryPin(SpinalLocation.L1, l1val < 0 ? "right" : "left", 0, cervical);
    const t1pin = this.renderThermalSummaryPin(SpinalLocation.T1, t1val < 0 ? "right" : "left", 0, cervical);
    //const c2pin = this.renderThermalSummaryPin(SpinalLocation.C2, c2val < 0 ? "right" : "left");
    const c1pin = this.renderThermalSummaryPin(SpinalLocation.C1, "none", c1width, cervical);

    if(cervical) {
      this.renderThermalSummaryPin(SpinalLocation.T2, t2val < 0 ? "right" : "left", 0, cervical);
      this.renderThermalSummaryPin(SpinalLocation.C1, "none", 0, cervical, true);
    }

    if (this.showBias) {
      this.renderBias(this.scan.Bias);
    }

    if (this.showLegend) {
      this.renderLegend();
    }
  }

  // Renders the spine location pins
  private renderThermalSummaryPin(loc: SpinalLocation, side: string = "none", value: number = 0, cervical: boolean = false, c0?: boolean) {

    let x = 0, y = 0, rot = 0;

    if (side == "left") {
      x = -75;
      rot = -90;
    } else if (side == "right") {
      x = 75;
      rot = 90;
    } else {
      y = -75;
    }

    // Create the pin
    const pin = new Konva.Path({
      x: this.stageWidth / 2 + value,
      y: c0 ? 250 : this.getSpinePositionFor(loc, cervical) + spineHeight / 2,
      rotation: rot,
      data: ScanViewUtils.pinPathCubicBezier(75, 115),
      fill: "#0f477a",
      stroke: "black",
      strokeWidth: 2,
      // shadowColor: 'black',
      // shadowOffset: {x: 0, y: 0},
      // shadowBlur: 5,
      // shadowOpacity: 0.5
    });

    // Make text
    const pinText = new Konva.Text({
      x: this.stageWidth / 2 + x + value,
      y: pin.y() + y,
      text: c0 ? 'C0' : SpinalLocation[loc],
      fontSize: 34,
      fontFamily: "Lato",
      fill: "white",
    });

    pinText.offset({
      x: pinText.width() / 2,
      y: pinText.height() / 2,
    });

    this.data.add(pin, pinText);

    return [pin, pinText];

  }

  // endregion

  /// region SHARED

  private renderBias(value: Decimal, duration: number = 0.5) {
    const desc = `${value.greaterThan(0) ? "Right" : "Left"} Shift: ${value.abs().toFixed(1)} degrees`;

    const boxWidth = this.stageWidth / 4;

    // Make the bar
    const biasBox = new Konva.Rect({
      x: 0,
      y: 50,
      width: boxWidth,
      height: 100,
      fillLinearGradientStartPoint: { x : 200, y : 0},
      fillLinearGradientEndPoint: { x : boxWidth, y : 0},
      fillLinearGradientColorStops: [0, "#0f477a", 1, "white"],
    });

    // Make the text
    const biasText = new Konva.Text({
      x: biasBox.x() + 50,
      y: biasBox.y() + biasBox.height() / 2,
      text: desc,
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: "black",
    });

    // @ts-ignore
    biasText.setOffset({
      y: biasText.getHeight() / 2,
    });

    // Add to layer
    //this.bias.add(biasBox);
    this.bias.add(biasText);
  }

  private renderLegend(duration: number = 0.25) {
    // let boxWidth = this.stageWidth / 4 + 100;

    // Make the bar
    const legendBox = new Konva.Rect({
      // x: this.stageWidth - boxWidth - 50,
      y: 50,
      // width: boxWidth,
      height: 100,
      stroke: "black",
      strokeWidth: 1,
    });

    // Make the text
    const mildText = new Konva.Text({
      // x: legendBox.x() + 50,
      y: legendBox.y() + legendBox.height() / 2,
      text: "Mild",
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: colorGreen,
    });

    // @ts-ignore
    mildText.setOffset({
      y: mildText.getHeight() / 2,
    });

    // Make the text
    const modText = new Konva.Text({
      // x: mildText.x() + mildText.width() + 50,
      y: legendBox.y() + legendBox.height() / 2,
      text: "Moderate",
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: colorBlue,
    });

    // @ts-ignore
    modText.setOffset({
      y: modText.getHeight() / 2,
    });

    // Make the text
    const sigText = new Konva.Text({
      // x: modText.x() + modText.width() + 50,
      y: legendBox.y() + legendBox.height() / 2,
      text: "Significant",
      align: "left",
      fontFamily: "Lato",
      fontSize: 38,
      fill: colorRed,
    });

    // @ts-ignore
    sigText.setOffset({
      y: sigText.getHeight() / 2,
    });

    const boxWidth = 50 + mildText.width() + 50 + modText.width() + 50 + sigText.width() + 50;

    // Resize box based on text sizes
    legendBox.x(this.stageWidth - boxWidth - 50);
    legendBox.width(boxWidth);

    mildText.x(legendBox.x() + 50);
    modText.x(mildText.x() + mildText.width() + 50);
    sigText.x(modText.x() + modText.width() + 50);

    this.legend.add(legendBox);
    this.legend.add(mildText);
    this.legend.add(modText);
    this.legend.add(sigText);
  }

  /// endregion

  /// region LIVE DATA

  private updateLiveView() {
    switch (this.scanViewType) {
      case ScanViewType.THERMAL_LINE:
        this.renderThermalLineLive();
        break;

      case ScanViewType.THERMAL_NCM:
        this.renderThermalNcmLive();
        this.stage.draw();
        break;

      case ScanViewType.THERMAL_CERVICAL_NCM:
        this.renderThermalNcmLive(true);
        this.stage.draw();
        break;

      case ScanViewType.EMG_AMPLITUDE:
        this.renderEmgAmplitudeLive();
        this.stage.draw();
        break;

      case ScanViewType.HRV_PULSE:
        this.renderHrvPulseLive();
        break;

      case ScanViewType.EMG_ENHANCED:
        this.renderEmgEnhancedLive();
        break;

      case ScanViewType.EMG_LIVE:
        this.renderEmgLineLive();
        break;

      case ScanViewType.ALGO:
        this.renderAlgoLive();
        this.stage.draw();
        break;
    }
  }

  // ngOnChanges(changes) {
  // }

}

// This hold all of our standard deviations and means and handles color calculations
// This will allow us to abstract the data calls and change it if necessary in the future
// You're welcome future Jake / Daniel ;)
export class ScanViewUtils {

  public static ThermalCalcData: Dict<SpinalLocation, CalcData> = new Dict<SpinalLocation, CalcData>();
  public static EmgCalcData: Dict<SpinalLocation, CalcData> = new Dict<SpinalLocation, CalcData>();
  public static HighWeight: Decimal = new Decimal(5);
  public static MaxImb: Decimal = new Decimal(3.70000004768372);
  public static ImbWeight: Decimal = new Decimal(25);
  public static HrvBpmWindow: Decimal = new Decimal(0.3);
  public static RawPerc: Decimal = new Decimal(0.30000001192092896);
  public static ThermalImbCap: Decimal = new Decimal(7);

  // Standard emg spinal location list
  // Readings added that are not in this list will not have a center location label
  // TODO: Make non standard spinal locations add labels
  public static EmgLocations: SpinalLocation[] = [

  ];

  // TODO: Pull standard deviation and means from database or server
  // As of building this, Sd and Mean are the same for each section, and same for L/R on thermal
  public static init() {

    // Thermal
    // C1 - C7
    ScanViewUtils.ThermalCalcData[SpinalLocation.C1] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C2] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C3] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C4] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C5] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C6] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};
    ScanViewUtils.ThermalCalcData[SpinalLocation.C7] = {LeftSd: 0.29, LeftMean: 0.41, RightSd: 0.29, RightMean: 0.41};

    // T1 - T12
    ScanViewUtils.ThermalCalcData[SpinalLocation.T1] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T2] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T3] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T4] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T5] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T6] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T7] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T8] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T9] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T10] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T11] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};
    ScanViewUtils.ThermalCalcData[SpinalLocation.T12] = {LeftSd: 0.31, LeftMean: 0.36, RightSd: 0.31, RightMean: 0.36};

    // L1 - L5
    ScanViewUtils.ThermalCalcData[SpinalLocation.L1] = {LeftSd: 0.34, LeftMean: 0.40, RightSd: 0.34, RightMean: 0.40};
    ScanViewUtils.ThermalCalcData[SpinalLocation.L2] = {LeftSd: 0.34, LeftMean: 0.40, RightSd: 0.34, RightMean: 0.40};
    ScanViewUtils.ThermalCalcData[SpinalLocation.L3] = {LeftSd: 0.34, LeftMean: 0.40, RightSd: 0.34, RightMean: 0.40};
    ScanViewUtils.ThermalCalcData[SpinalLocation.L4] = {LeftSd: 0.34, LeftMean: 0.40, RightSd: 0.34, RightMean: 0.40};
    ScanViewUtils.ThermalCalcData[SpinalLocation.L5] = {LeftSd: 0.34, LeftMean: 0.40, RightSd: 0.34, RightMean: 0.40};

    // S1 - S5
    ScanViewUtils.ThermalCalcData[SpinalLocation.S1] = {LeftSd: 0.34, LeftMean: 0.5, RightSd: 0.34, RightMean: 0.5};
    ScanViewUtils.ThermalCalcData[SpinalLocation.S2] = {LeftSd: 0.34, LeftMean: 0.5, RightSd: 0.34, RightMean: 0.5};
    ScanViewUtils.ThermalCalcData[SpinalLocation.S3] = {LeftSd: 0.34, LeftMean: 0.5, RightSd: 0.34, RightMean: 0.5};
    ScanViewUtils.ThermalCalcData[SpinalLocation.S4] = {LeftSd: 0.34, LeftMean: 0.5, RightSd: 0.34, RightMean: 0.5};
    ScanViewUtils.ThermalCalcData[SpinalLocation.S5] = {LeftSd: 0.34, LeftMean: 0.5, RightSd: 0.34, RightMean: 0.5};

    // EMG
    // C1 - C7
    ScanViewUtils.EmgCalcData[SpinalLocation.C1] = {LeftSd: 1.6, LeftMean: 3.8, RightSd: 1.8, RightMean: 3.9};
    ScanViewUtils.EmgCalcData[SpinalLocation.C2] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.C3] = {LeftSd: 1.8, LeftMean: 4.4, RightSd: 1.7, RightMean: 4.3};
    ScanViewUtils.EmgCalcData[SpinalLocation.C4] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.C5] = {LeftSd: 1.8, LeftMean: 4.2, RightSd: 1.8, RightMean: 4.1};
    ScanViewUtils.EmgCalcData[SpinalLocation.C6] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.C7] = {LeftSd: 1.9, LeftMean: 4.8, RightSd: 2, RightMean: 4.6};

    // T1 - T12
    ScanViewUtils.EmgCalcData[SpinalLocation.T1] = {LeftSd: 2.7, LeftMean: 4.9, RightSd: 2.6, RightMean: 4.9};
    ScanViewUtils.EmgCalcData[SpinalLocation.T2] = {LeftSd: 2.8, LeftMean: 5, RightSd: 2.9, RightMean: 5};
    ScanViewUtils.EmgCalcData[SpinalLocation.T3] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.T4] = {LeftSd: 3, LeftMean: 6.5, RightSd: 3.2, RightMean: 6.4};
    ScanViewUtils.EmgCalcData[SpinalLocation.T5] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.T6] = {LeftSd: 3.5, LeftMean: 8.4, RightSd: 3.5, RightMean: 8.2};
    ScanViewUtils.EmgCalcData[SpinalLocation.T7] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.T8] = {LeftSd: 4.1, LeftMean: 9.6, RightSd: 4.5, RightMean: 9.5};
    ScanViewUtils.EmgCalcData[SpinalLocation.T9] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.T10] = {LeftSd: 4.2, LeftMean: 10, RightSd: 4.3, RightMean: 10};
    ScanViewUtils.EmgCalcData[SpinalLocation.T11] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.T12] = {LeftSd: 4.5, LeftMean: 9.8, RightSd: 4.4, RightMean: 9.8};

    // L1 - L5
    ScanViewUtils.EmgCalcData[SpinalLocation.L1] = {LeftSd: 4.1, LeftMean: 8.7, RightSd: 4, RightMean: 8.7};
    ScanViewUtils.EmgCalcData[SpinalLocation.L2] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.L3] = {LeftSd: 3.1, LeftMean: 6.1, RightSd: 3.4, RightMean: 6.2};
    ScanViewUtils.EmgCalcData[SpinalLocation.L4] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.L5] = {LeftSd: 3.2, LeftMean: 5.2, RightSd: 3.5, RightMean: 5.3};

    // S1 - S5
    ScanViewUtils.EmgCalcData[SpinalLocation.S1] = {LeftSd: 2.7, LeftMean: 4.4, RightSd: 2.8, RightMean: 4.4};
    ScanViewUtils.EmgCalcData[SpinalLocation.S2] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.S3] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.S4] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
    ScanViewUtils.EmgCalcData[SpinalLocation.S5] = {LeftSd: 0, LeftMean: 0, RightSd: 0, RightMean: 0};
  }

  public static getThermalNormative(): Scan {
    let normScan = {
      CreatedStamp: new Date(),
      PatientId: '',
      DoctorId: '',
      ScanData: [
        // Norm data is static
        <ThermalScanData>{SpinalLocation: SpinalLocation.C1, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.C2, LeftValue: new Decimal(0.3), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.C3, LeftValue: new Decimal(0.3), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.C5, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.C6, LeftValue: new Decimal(0), RightValue: new Decimal(0.2)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.C7, LeftValue: new Decimal(0), RightValue: new Decimal(0.1)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T4, LeftValue: new Decimal(0.3), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T5, LeftValue: new Decimal(0.3), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T7, LeftValue: new Decimal(0), RightValue: new Decimal(0.1)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T8, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T10, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T11, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.T12, LeftValue: new Decimal(0.2), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.L1, LeftValue: new Decimal(0.3), RightValue: new Decimal(0)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.L3, LeftValue: new Decimal(0), RightValue: new Decimal(0.3)},
        <ThermalScanData>{SpinalLocation: SpinalLocation.L4, LeftValue: new Decimal(0.1), RightValue: new Decimal(0)},
      ],
      Bias: new Decimal(0),
      ScanPosition: ScanPosition.Standing,
      ScanPurpose: ScanPurpose.Comparative,
      BodyType: BodyTypes.Adult,
      Invalid: false,
    };
    return normScan;
  }

  public  static getEMGNormative(): Scan {
    let normScan = {
      CreatedStamp: new Date(),
      PatientId: '',
      DoctorId: '',
      ScanData: [
        // Norm data is static
        <EMGScanData>{SpinalLocation: SpinalLocation.C1, LeftValue: new Decimal(3.8), RightValue: new Decimal(3.9)},
        <EMGScanData>{SpinalLocation: SpinalLocation.C3, LeftValue: new Decimal(4.4), RightValue: new Decimal(4.3)},
        <EMGScanData>{SpinalLocation: SpinalLocation.C5, LeftValue: new Decimal(4.2), RightValue: new Decimal(4.1)},
        <EMGScanData>{SpinalLocation: SpinalLocation.C7, LeftValue: new Decimal(4.8), RightValue: new Decimal(4.6)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T1, LeftValue: new Decimal(4.9), RightValue: new Decimal(4.9)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T2, LeftValue: new Decimal(5.0), RightValue: new Decimal(5.0)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T4, LeftValue: new Decimal(6.5), RightValue: new Decimal(6.4)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T6, LeftValue: new Decimal(8.4), RightValue: new Decimal(8.2)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T8, LeftValue: new Decimal(9.6), RightValue: new Decimal(9.5)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T10, LeftValue: new Decimal(10.0), RightValue: new Decimal(10.0)},
        <EMGScanData>{SpinalLocation: SpinalLocation.T12, LeftValue: new Decimal(9.8), RightValue: new Decimal(9.8)},
        <EMGScanData>{SpinalLocation: SpinalLocation.L1, LeftValue: new Decimal(8.7), RightValue: new Decimal(8.7)},
        <EMGScanData>{SpinalLocation: SpinalLocation.L3, LeftValue: new Decimal(6.1), RightValue: new Decimal(6.2)},
        <EMGScanData>{SpinalLocation: SpinalLocation.L5, LeftValue: new Decimal(5.2), RightValue: new Decimal(5.3)},
        <EMGScanData>{SpinalLocation: SpinalLocation.S1, LeftValue: new Decimal(4.4), RightValue: new Decimal(4.4)},
      ],
      ScanPosition: ScanPosition.Standing,
      ScanPurpose: ScanPurpose.Comparative,
      BodyType: BodyTypes.Adult,
      Invalid: false,
    };
    return normScan;
  }

  public static getHRVNormative(): Scan {
    let normScan = {
      CreatedStamp: new Date(),
      PatientId: '',
      DoctorId: '',
      ScanData: [
        // Norm data is static
        <HRVScanData>{
          AutonomicActivity: 99.49,
          AutonomicBalance: 99.84
        },
      ],
      ScanPosition: ScanPosition.Seated,
      ScanPurpose: ScanPurpose.Comparative,
      BodyType: BodyTypes.Adult,
      Invalid: false,
    };
    return normScan;
  }


  public static getEmgMaxValue(): number {

    let maxMean = 0, maxSd = 0;

    for (let x = 0; x <= 28; x ++) {
      maxMean = Math.max(maxMean, this.EmgCalcData[x].LeftMean, this.EmgCalcData[x].RightMean);
      maxSd = Math.max(maxSd, this.EmgCalcData[x].LeftSd, this.EmgCalcData[x].RightSd);
    }

    maxMean += maxSd * 4;

    // This appears to give us buffer space on our graph
    maxMean *= lisasMagicAdjustmentNumber;

    // Make it even
    maxMean += maxMean % 2;

    return maxMean;
  }

  public static getThermalBreakdown(scan: Scan, bias?: boolean): ThermalScanBreakdown {
    const stats: ThermalScanBreakdown = {
      ScoreVersion: '2.0',
      WhiteCount: 0,
      WhiteLocations: [],
      RedCount: 0,
      RedLocations: [],
      BlueCount: 0,
      BlueLocations: [],
      GreenCount: 0,
      GreenLocations: [],
      NonNormalCount: 0,
      TotalCount: 0,
    } as ThermalScanBreakdown;
    const weightedReadings = [];
    for (const scandata of scan.ScanData
      .filter((d: ThermalScanData) => d.SpinalLocation != undefined)
      .sort((d1: ThermalScanData, d2: ThermalScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as ThermalScanData;
      let dif = sd.RightValue.minus(sd.LeftValue).minus(scan.Bias);
      // chart in thermal report when thermal shift is off
      if(bias){
        dif = sd.RightValue.minus(sd.LeftValue);
      }
      const difabs = dif.abs();
      const std = new Decimal(this.ThermalCalcData[sd.SpinalLocation].LeftSd);
      const mean = new Decimal(this.ThermalCalcData[sd.SpinalLocation].LeftMean);

      let weightedReading: any;
      if (difabs.lessThan(std)) {
        weightedReading = difabs.dividedBy(mean);
      } else {
        weightedReading = (difabs.minus(mean).dividedBy(std)).plus(1);
      }
      if (weightedReading > 0) {
        if(weightedReading.greaterThan(this.ThermalImbCap.times(std))) {
          weightedReading = this.ThermalImbCap.times(std);
        }
        weightedReadings.push({Location: sd.SpinalLocation, TempValue: weightedReading});
      }


      const readingRange = ScanViewUtils.getThermalBand(sd.SpinalLocation, difabs);
      switch (readingRange) {
        case Band.NORMAL:
          stats.WhiteCount++;
          stats.WhiteLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          break;
        case Band.MILD:
          stats.GreenCount++;
          stats.GreenLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          break;
        case Band.MODERATE:
          stats.BlueCount++;
          stats.BlueLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          break;
        case Band.SIGNIFICANT:
          stats.RedCount++;
          stats.RedLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          break;
      }
    }

    const slope = (this.HighWeight.minus(1)).dividedBy(weightedReadings.length);
    let rank = 0;
    let sumWeightedValues = new Decimal(0);
    let sumWeights = new Decimal(0);
    for (const reading of weightedReadings
      .sort((d1: any, d2: any) => d1.TempValue - d2.TempValue)) {
      rank++;
      const weight = (slope.times(rank)).plus((new Decimal(1).minus(slope)));

      const weightedValue = weight.times(reading.TempValue);
      sumWeights = sumWeights.plus(weight);
      sumWeightedValues = sumWeightedValues.plus(weightedValue);
    }
    const weightedAvg = sumWeightedValues.dividedBy(sumWeights);
    if (weightedAvg.lessThanOrEqualTo(0.5)) {
      stats.Score = new Decimal(100);
    } else if (weightedAvg < this.MaxImb) {
      stats.Score = new Decimal(100).minus((weightedAvg.minus(0.5).times(this.ImbWeight)));
    } else {
      stats.Score = new Decimal(20);
    }
    if (stats.Score.greaterThanOrEqualTo(100)) {
      stats.Score = new Decimal(99);
    }
    stats.NonNormalCount = stats.GreenCount + stats.RedCount + stats.BlueCount;
    stats.TotalCount = stats.NonNormalCount + stats.WhiteCount;
    stats.Score = stats.Score.ceil();
    return stats;
  }

  public static getThermalBand(pos: SpinalLocation, value: Decimal): Band {

    // Subtract average for this location from the value
    const dif = value.minus(this.ThermalCalcData[pos].LeftMean);

    const std = new Decimal(this.ThermalCalcData[pos].LeftSd);

    if (dif.lessThan(std)) {
      return Band.NORMAL;
    } else if (dif.lessThan(std.mul(2))) {
      return Band.MILD;
    } else if (dif.lessThan(std.mul(3))) {
      return Band.MODERATE;
    } else {
      return Band.SIGNIFICANT;
    }
  }

  public static getEmgBand(pos: SpinalLocation, value: Decimal): Band {

    const right = value.greaterThan(0);

    // Subtract average for this location from the value
    const dif = value.abs().minus(right ? this.EmgCalcData[pos].RightMean : this.EmgCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(right ? this.EmgCalcData[pos].RightSd : this.EmgCalcData[pos].LeftSd);
    const mean = new Decimal(right ? this.EmgCalcData[pos].RightMean : this.EmgCalcData[pos].LeftMean);
    const upperRange = new Decimal(std).mul(-1);

     if (dif.lessThan(upperRange)) {
      return Band.HYPO;
    } else if (dif.lessThan(std)) {
     return Band.NORMAL;
    } else if (dif.lessThan(std.mul(2))) {
      return Band.MILD;
    } else if (dif.lessThan(std.mul(3))) {
      return Band.MODERATE;
    } else {
      return Band.SIGNIFICANT;
    }
  }

  public static getThermalBarRange(pos: SpinalLocation, value: Decimal): any {
    // Subtract average for this location from the value
    const colorDif = value.minus(this.ThermalCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(this.ThermalCalcData[pos].LeftSd);

    // Start with a white bar
    let range = colorWhite;

    if (colorDif < std) {
      range = colorWhite;
    } else if (colorDif < std.mul(2)) {
      range = colorGreen;
    } else if (colorDif < std.mul(3)) {
      range = colorBlue;
    } else {
      range = colorRed;
    }

    return range;
  }

  public static getThermalBarColor(pos: SpinalLocation, value: Decimal): any {

    // Subtract average for this location from the value
    const colorDif = value.minus(this.ThermalCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(this.ThermalCalcData[pos].LeftSd);

    // Start with a white bar
    let targetColorStops = [0, colorWhite, 1, colorWhiteEnd];

    if (colorDif.lessThan(std)) {
      targetColorStops = [0, colorWhite, 1, colorWhiteEnd];
    } else if (colorDif.lessThan(std.mul(2))) {
      targetColorStops = [0, colorGreen, 1, colorGreenEnd];
    } else if (colorDif.lessThan(std.mul(3))) {
      targetColorStops = [0, colorBlue, 1, colorBlueEnd];
    } else {
      targetColorStops = [0, colorRed, 1, colorRedEnd];
    }

    return targetColorStops;
  }

  public static getThermalBarColorIndex(pos: SpinalLocation, value: Decimal): any {

    // Subtract average for this location from the value
    const colorDif = value.minus(this.ThermalCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(this.ThermalCalcData[pos].LeftSd);

    // Start with a white bar
    let index = 0;

    if (colorDif.lessThan(std)) {
      index = 0;
    } else if (colorDif.lessThan(std.mul(2))) {
      index = 1;
    } else if (colorDif.lessThan(std.mul(3))) {
      index = 2;
    } else {
      index = 3;
    }

    return index;
  }

  public static getEmgBreakdown(scan: Scan): EmgScanBreakdown {
    const stats: EmgScanBreakdown = {
      ScoreVersion: '2.0',
      YellowCount: 0,
      YellowLocations: [],
      WhiteCount: 0,
      WhiteLocations: [],
      RedCount: 0,
      RedLocations: [],
      BlueCount: 0,
      BlueLocations: [],
      GreenCount: 0,
      GreenLocations: [],
      NonNormalCount: 0,
      NonNormalLocations: [],
      TotalCount: 0,
    } as EmgScanBreakdown;
    //filter emg with crappy data
    scan.ScanData = scan.ScanData.filter((X: EMGScanData) => X.RightValue.toNumber() > 0)
    scan.ScanData.reverse();
    scan.ScanData = scan.ScanData.reduce((P, C:EMGScanData) => {
      const X = P.find(S => (S.SpinalLocation === C.SpinalLocation));
      if(!X){ return P.concat([C]);
      } else { return P;}}, []);
    for (const scandata of scan.ScanData
      .filter((d: EMGScanData) => d.SpinalLocation != undefined)
      .sort((d1: EMGScanData, d2: EMGScanData) => d1.SpinalLocation - d2.SpinalLocation)) {
      const sd = scandata as EMGScanData;

      const leftColor = ScanViewUtils.getEmgBand(sd.SpinalLocation, sd.LeftValue.times(-1));
      switch (leftColor) {
        case Band.HYPO:
          stats.YellowLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(L)');
          stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          stats.YellowCount++;
          break;
        case Band.NORMAL:
          stats.WhiteLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(L)');
          stats.WhiteCount++;
          break;
        case Band.MILD:
          stats.GreenLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(L)');
          stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          stats.GreenCount++;
          break;
        case Band.MODERATE:
          stats.BlueLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(L)');
          stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          stats.BlueCount++;
          break;
        case Band.SIGNIFICANT:
          stats.RedLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(L)');
          stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          stats.RedCount++;
          break;
      }

      const rightColor = ScanViewUtils.getEmgBand(sd.SpinalLocation, sd.RightValue);
      switch (rightColor) {
        case Band.HYPO:
          stats.YellowLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(R)');
          if(stats.NonNormalLocations.indexOf(SpinalLocation[sd.SpinalLocation.toString()]) == -1)
          {
            stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          }
          stats.YellowCount++;
          break;
        case Band.NORMAL:
          stats.WhiteLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(R)');
          stats.WhiteCount++;
          break;
        case Band.MILD:
          stats.GreenLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(R)');
          if(stats.NonNormalLocations.indexOf(SpinalLocation[sd.SpinalLocation.toString()]) == -1)
          {
            stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          }
          stats.GreenCount++;
          break;
        case Band.MODERATE:
          stats.BlueLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(R)');
          if(stats.NonNormalLocations.indexOf(SpinalLocation[sd.SpinalLocation.toString()]) == -1)
          {
            stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          }
          stats.BlueCount++;
          break;
        case Band.SIGNIFICANT:
          stats.RedLocations.push(SpinalLocation[sd.SpinalLocation.toString()]+'(R)');
          if(stats.NonNormalLocations.indexOf(SpinalLocation[sd.SpinalLocation.toString()]) == -1)
          {
            stats.NonNormalLocations.push(SpinalLocation[sd.SpinalLocation.toString()]);
          }
          stats.RedCount++;
          break;
      }
    }

    const energyScore = ScanViewUtils.calcEmgEnergyScore(scan);
    stats.EnergyScore = new Decimal(energyScore);
    if (energyScore.greaterThan(250)) {
      stats.EnergyBand = Band.SIGNIFICANT;
    } else if (energyScore.greaterThan(120)) {
      stats.EnergyBand = Band.MODERATE;
    } else {
      stats.EnergyBand = Band.MILD;
    }

    const patternScore = ScanViewUtils.calcEmgPatternScore(scan);
    stats.PatternScore = new Decimal(patternScore);
    if (patternScore.greaterThan(80)) {
      stats.PatternBand = Band.MILD;
    } else if (patternScore.greaterThan(60)) {
      stats.PatternBand = Band.MODERATE;
    } else  {
      stats.PatternBand = Band.SIGNIFICANT;
    }

    const symmetryScore = ScanViewUtils.calcEmgSymmetryScore(scan);
    stats.SymmetryScore = new Decimal(symmetryScore);
    if (symmetryScore.greaterThan(80)) {
      stats.SymmetryBand = Band.MILD;
    } else if (symmetryScore.greaterThan(60)) {
      stats.SymmetryBand = Band.MODERATE;
    } else  {
      stats.SymmetryBand = Band.SIGNIFICANT;
    }

    stats.Score = ScanViewUtils.calcEmgScanScore(stats.EnergyScore,stats.PatternScore,stats.SymmetryScore)
    stats.Score = stats.Score.ceil();

    stats.NonNormalCount = stats.GreenCount + stats.RedCount + stats.BlueCount + stats.YellowCount;
    stats.TotalCount = stats.NonNormalCount + stats.WhiteCount;
    return stats;
  }

  public static calcEmgScanScore(energyScore: Decimal, patternScore: Decimal, symmetryScore: Decimal): Decimal {
    let Score = new Decimal(0);
    let patternSymmetryAverage = patternScore.times(0.6).plus(symmetryScore.times(0.4));
    if (energyScore.lessThan(50) || energyScore.greaterThanOrEqualTo(150)) {
      // Score = 0.9F * (0.6F * (float)Pattern.PatternVal + 0.4F * (float)Pattern.SymmetryVal);
      Score = patternSymmetryAverage.times(0.9);
    } else if (energyScore.lessThan(75)) {
      // Score = (0.7F + 0.004F * (float)Pattern.TotalEnergyVal) * (0.6F * (float)Pattern.PatternVal + 0.4F * (float)Pattern.SymmetryVal);
      Score =(energyScore.times(.004).plus(0.7)).times(patternSymmetryAverage);
    } else if (energyScore.lessThan(125)) {
      // Score = 0.6F * (float)Pattern.PatternVal + 0.4F * (float)Pattern.SymmetryVal;
      Score =  patternSymmetryAverage;
    } else if (energyScore.lessThan(150)) {
      // Score = (1.5F - 0.004F * (float)Pattern.TotalEnergyVal) * (0.6F * (float)Pattern.PatternVal + 0.4F * (float)Pattern.SymmetryVal);
      Score = new Decimal(1.5).minus(energyScore.times(0.004)).times(patternSymmetryAverage);
    }
    return Score;
  }

  public static getEmgTriangleColor(value: Decimal): any {

    // Start with a white bar
    let targetColorStops = [0, colorWhite, 1, colorWhiteEnd];

    if (value.lessThanOrEqualTo(20)) {
      targetColorStops = [0, colorWhite, 1, colorWhiteEnd];
    } else if (value.lessThanOrEqualTo(35)) {
      targetColorStops = [0, colorGreen, 1, colorGreenEnd];
    } else if (value.lessThanOrEqualTo(75)) {
      targetColorStops = [0, colorBlue, 1, colorBlueEnd];
    } else {
      targetColorStops = [0, colorRed, 1, colorRedEnd];
    }

    return targetColorStops;
  }

  public static getEmgBarColor(pos: SpinalLocation, value: Decimal, scale: number): any {

    const right = value.greaterThan(0);

    if(value.abs().greaterThan(scale)) {
      return [0, colorBlack, 1, colorBlackEnd];
    }
    // Subtract average for this location from the value
    const colorDif = value.abs().minus(right ? this.EmgCalcData[pos].RightMean : this.EmgCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(right ? this.EmgCalcData[pos].RightSd : this.EmgCalcData[pos].LeftSd);
    // Start with a white bar
    let targetColorStops = [0, colorWhite, 1, colorWhiteEnd];
    const upperRange = new Decimal(std).mul(-1);

    if (colorDif.lessThan(upperRange)) {
      targetColorStops = [0, colorYellow, 1, colorYellowEnd];
    } else if (colorDif.lessThan(std)) {
      targetColorStops = [0, colorWhite, 1, colorWhiteEnd];
    } else if (colorDif.lessThan(std.mul(2))) {
      targetColorStops = [0, colorGreen, 1, colorGreenEnd];
    } else if (colorDif.lessThan(std.mul(3))) {
      targetColorStops = [0, colorBlue, 1, colorBlueEnd];
    } else {
      targetColorStops = [0, colorRed, 1, colorRedEnd];
    }

    return targetColorStops;
  }

  public static getEmgBarColorIndex(pos: SpinalLocation, value: Decimal): any {

    const right = value.greaterThan(0);

    // Subtract average for this location from the value
    const colorDif = value.abs().minus(right ? this.EmgCalcData[pos].RightMean : this.EmgCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(right ? this.EmgCalcData[pos].RightSd : this.EmgCalcData[pos].LeftSd);

    // Start with a white bar
    let index = 0;
    const upperRange = new Decimal(std).mul(-1);

    if (colorDif.lessThan(upperRange)) {
      index = 0;
    } else if (colorDif.lessThan(std)) {
      index = 1;
    } else if (colorDif.lessThan(std.mul(2))) {
      index = 2;
    } else if (colorDif.lessThan(std.mul(3))) {
      index = 3;
    } else {
      index = 4;
    }

    return index;
  }

  public static getThermalBarColorSingle(pos: SpinalLocation, value: Decimal): any {

    // Subtract average for this location from the value
    const colorDif = value.minus(this.ThermalCalcData[pos].LeftMean);

    // Get the standard deviation
    const std = new Decimal(this.ThermalCalcData[pos].LeftSd);

    // Start with a white bar
    let targetColorStops = colorWhite;

    if (colorDif.lessThan(std)) {
      targetColorStops = colorWhite;
    } else if (colorDif.lessThan(std.mul(2))) {
      targetColorStops = colorGreen;
    } else if (colorDif.lessThan(std.mul(3))) {
      targetColorStops = colorBlue;
    } else {
      targetColorStops = colorRed;
    }

    return targetColorStops;
  }

  public static calcCoreScore(hrvScore: number, emgScore: number, thermalScore: number): {Score: number, Version: string, Rating: string} {
    let result: {Score: number, Version: string, Rating: string} =
      {Score: 0, Version: '0.2', Rating: ''};
    let hrvWeight = hrvScore * 40;
    let emgWeight = emgScore * 35;
    let thermalWeight = thermalScore * 25;

    result.Score = (hrvWeight + emgWeight + thermalWeight) / 100;

    result.Rating = this.getCoreScoreRating(result.Score);
    return result;
  }

  public static getCoreScoreRating(coreScore: number): string {
    if(coreScore <60) {
      return 'Very Challenged';
    } else if (coreScore < 70) {
      return 'Challenged';
    } else if (coreScore < 80) {
      return 'Transition';
    } else if (coreScore < 90) {
      return 'Good';
    } else if (coreScore < 95) {
      return 'Very Good';
    } else {
      return 'Excellent';
    }
  }

  public static calcPedCoreScore(hrvScore: number, emgScore: number, thermalScore: number): {Score: number, Version: string, Rating: string} {
    let result: {Score: number, Version: string, Rating: string} =
      {Score: 0, Version: 'ped0.2', Rating: ''};
    let hrvWeight = hrvScore * 25;
    let emgWeight = emgScore * 35;
    let thermalWeight = thermalScore * 40;

    result.Score = (hrvWeight + emgWeight + thermalWeight) / 100;

    if(result.Score >= 79) {
      result.Rating = 'Above';
    } else {
      result.Rating = 'Below';
    }
    return result;
  }

  public static getPedCoreScoreRating(coreScore: number, language): string {
    if (language === 'English') {
      if (coreScore >= 79) {
        return 'Above';
      } else {
        return 'Below';
      }
    } else if (language === 'French') {
      if (coreScore >= 79) {
        return 'au dessus';
      } else {
        return 'plus bas';
      }
    } else if (language === 'Spanish') {
      if (coreScore >= 79) {
        return 'por arriba de lo';
      } else {
        return 'por debajo de lo';
      }
    } else if (language === 'German') {
      if (coreScore >= 79) {
        return 'über';
      } else {
        return 'unten';
      }
    } else if (language === 'Norwegian') {
      if (coreScore >= 79) {
        return 'over';
      } else {
        return 'under';
      }
    } else if (language === 'Italian') {
      if (coreScore >= 79) {
        return 'sopra';
      } else {
        return 'Sotto';
      }
    } else if (language === 'Dutch') {
      if (coreScore >= 79) {
        return 'boven';
      } else {
        return 'onder';
      }
    } else if (language === 'Portuguese') {
      if (coreScore >= 79) {
        return 'acima';
      } else {
        return 'bbaixo';
      }
    }
  }

  public static setCoreScoreRank(scores: number[], language) : {Excellent: string, VeryGood: string, Good: string, Transition: string, Challenged: string, VeryChallenged: string} {
    let chart: {Excellent: string, VeryGood: string, Good: string, Transition: string, Challenged: string, VeryChallenged: string} = {Excellent:'',VeryGood:'',Good:'',Transition:'',Challenged:'',VeryChallenged:''};
    scores.forEach((score, i)=>{
      let scanLabel = this.translateExam(language) + (i+1);
      if(score <60) {
        if (chart.VeryChallenged.length == 0) {
          chart.VeryChallenged += scanLabel;
        } else {
          chart.VeryChallenged += ', ' + (i+1);
        }
      } else if (score < 70) {
        if (chart.Challenged.length == 0) {
          chart.Challenged += scanLabel;
        } else {
          chart.Challenged += ', ' + (i+1);
        }
      } else if (score < 80) {
        if (chart.Transition.length == 0) {
          chart.Transition += scanLabel;
        } else {
          chart.Transition += ', ' + (i+1);
        }
      } else if (score < 90) {
        if (chart.Good.length == 0) {
          chart.Good += scanLabel;
        } else {
          chart.Good += ', ' + (i+1);
        }
      } else if (score < 95) {
        if (chart.VeryGood.length == 0) {
          chart.VeryGood += scanLabel;
        } else {
          chart.VeryGood += ', ' + (i+1);
        }
      } else {
        if (chart.Excellent.length == 0) {
          chart.Excellent += scanLabel;
        } else {
          chart.Excellent += ', ' + (i+1);
        }
      }
    });

    return chart;
  }

  public static calcEmgEnergyScore(scan: Scan): Decimal {
    let readingSum = new Decimal(0);
    let meanSum = 0;

    // Calculate scan data sum
    scan.ScanData.map((d: EMGScanData) => {
      readingSum = readingSum.plus(d.LeftValue.plus(d.RightValue));
      meanSum += this.EmgCalcData[d.SpinalLocation].LeftMean + this.EmgCalcData[d.SpinalLocation].RightMean;
    });

    // Calculate mean sum
    // for (let x = 0; x <= 28; x ++) {
    //   meanSum += this.EmgCalcData[x].LeftMean + this.EmgCalcData[x].RightMean;
    // }
    return readingSum.dividedBy(meanSum).times(100);

  }

  public static calcEmgPatternScore(scan: Scan): Decimal {
    const scaleFactor = this.calcEmgScaleFactor(scan);
    // let readingCount = 0;
    let sumAvgs = new Decimal(0);

    for (const data of scan.ScanData) {
      const sd = data as EMGScanData;

      const normData = this.EmgCalcData[sd.SpinalLocation];

      // Left
      sumAvgs = sumAvgs.plus(
        ((sd.LeftValue.times(scaleFactor).minus(normData.LeftMean)).dividedBy(normData.LeftMean)).abs()
      );

      // Right
      sumAvgs = sumAvgs.plus(
        ((sd.RightValue.times(scaleFactor).minus(normData.RightMean)).dividedBy(normData.RightMean)).abs()
      );
    }

    sumAvgs = sumAvgs.dividedBy(scan.ScanData.length * 2);
    // Pattern formula from lee? Circa 2007

    if (sumAvgs.lessThanOrEqualTo(0.15)) {
      return new Decimal(99);
    }

    if (sumAvgs.lessThanOrEqualTo(0.95)) {
      return new Decimal(1).minus(sumAvgs.minus(0.15)).times(100);
    }

    return new Decimal(20);
  }

  public static calcEmgSymmetryScore(scan: Scan): Decimal {
    let sumDiffs = new Decimal(0);

    for (const data of scan.ScanData) {
      const sd = data as EMGScanData;

      sumDiffs = sumDiffs
        .plus(
          sd.LeftValue.minus(sd.RightValue)
            .dividedBy(
              sd.LeftValue.plus(sd.RightValue)
                .dividedBy(2)).abs());
    }

    sumDiffs = sumDiffs.dividedBy(scan.ScanData.length);

    if (sumDiffs.lessThanOrEqualTo(0.075)) {
      return new Decimal(100);
    }

    if (sumDiffs.lessThan(0.875)) {
      return new Decimal(1).minus(sumDiffs.minus(0.075)).times(100);
    }

    return new Decimal(20);
  }

  public static async loadEmgScan(id: string, api: any) : Promise<Scan> {
    let tempScan = await api.getScanById(id).toPromise();
    // Transform data
    tempScan.ScanData = tempScan.ScanData.map((sd: any) =>{
      if (sd.SpinalLocation != undefined) {
        return <EMGScanData>{
          SpinalLocation: SpinalLocation[<string>sd.SpinalLocation],
          LeftValue: new Decimal(sd.LeftValue),
          RightValue: new Decimal(sd.RightValue)
        };
      }
    });
    return tempScan;
  }

  public static parseByteArray(str: string) {
    return new Uint8Array(str.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
  }

  public static async loadThermalScan(id: string, api: any) : Promise<Scan> {
    let tempScan = await api.getScanById(id).toPromise();
    let scanTypeStr: string  = tempScan.ScanType.trim();
    tempScan.ScanType = ScanTypes[scanTypeStr];
    // Transform data
    tempScan.ScanData = tempScan.ScanData.map((sd: any) =>{
      if (sd.SpinalLocation != undefined) {
        return <ThermalScanData>{
          SpinalLocation: SpinalLocation[<string>sd.SpinalLocation],
          LeftValue: new Decimal(sd.LeftValue),
          RightValue: new Decimal(sd.RightValue)
        };
      } else if (sd.RawData) {
        let readings = ScanViewUtils.parseByteArray(sd.RawData);

        let view = new DataView(readings.buffer);

        let rollingData: ThermalRollingData = {
          LeftReadings: [],
          RightReadings: [],
          DistanceReadings: [],
          EventMarkers: []
        };

        for (let i=0; i<readings.length; i+=24) {

          rollingData.LeftReadings.push(new Decimal(view.getFloat32(i, true)).plus(view.getFloat32(i + 8, true) * tempScan.OffsetL));
          rollingData.RightReadings.push(new Decimal(view.getFloat32(i + 4, true)).plus(view.getFloat32(i + 12, true) * tempScan.OffsetR));
          rollingData.DistanceReadings.push(new Decimal(view.getFloat32(i + 16, true)));
          let evt = view.getInt32(i + 20, true);
          if (evt > 0) {
            evt++;
          }
          rollingData.EventMarkers.push(evt);

        }

        return rollingData;
      }
    });

    tempScan.Bias = new Decimal(tempScan.Bias);

    // Set
    return tempScan;
  }

  public static checkThermalRolling(scan: Scan): boolean{
    for(let sd of scan.ScanData) {
      let tsd = <any>sd;
      if(tsd.DistanceReadings) return true;
    }
    return false;
  }

  public static async loadAlgoScan(id: string, api: any) : Promise<Scan> {
    let tempScan = await api.getScanById(id).toPromise();
    // Transform data
    tempScan.ScanData = tempScan.ScanData.map((sd: any) => {
      return <AlgoScanData> {
        SpinalLocation: SpinalLocation[<string>sd.SpinalLocation],
        BaselineFlag: sd.BaselineFlag,
        LeftValue: new Decimal(sd.LeftValue),
        CenterValue: new Decimal(sd.CenterValue),
        RightValue: new Decimal(sd.RightValue)
      }
    });
    tempScan.Bias = new Decimal(0);
    return tempScan;
  }

  public static async loadRomScan(id: string, api: any) : Promise<Scan> {
    let tempScan = await api.getScanById(id).toPromise();
    // Transform data
    tempScan.ScanData = tempScan.ScanData.map((sd: any) => {
      return <ROMScanData> {
        TestType: RomTestTypes[<string>sd.TestType],
        ResultType: RomResultTypes[<string>sd.ResultType],
        DataValue: sd.DataValue,
        InvalidFlag: sd.InvalidFlag
      }
    });
    tempScan.Bias = new Decimal(0);
    return tempScan;
  }

  public static async loadHrvScan(id: string, api: any) : Promise<Scan> {
    let tempScan = await api.getScanById(id).toPromise();
    // Transform data
    let scanData = <HRVScanData>tempScan.ScanData[0];
    scanData.RawPpgDecoded = this.decodeHrvObject(scanData.RawPpg);
    if(scanData.RawScr != null && scanData.RawTemp.length > 0 && scanData.EarClipFlag === false) {
      scanData.RawScrDecoded = this.decodeHrvObject(scanData.RawScr);
    } else {
      scanData.RawScrDecoded = <[{TimeStamp: number, DataValue: Decimal}]>[];
    }
    if(scanData.RawTemp != null && scanData.RawTemp.length > 0) {
      scanData.RawTempDecoded = this.decodeHrvObject(scanData.RawTemp);
    } else {
      scanData.RawTempDecoded = <[{TimeStamp: number, DataValue: Decimal}]>[];
    }

    // Set
    return tempScan;
  }

  public static decodeHrvObject(rawData: any) : [{TimeStamp: number, DataValue: Decimal}]
  {
    let data = ScanViewUtils.parseByteArray(rawData);
    let view = new DataView(data.buffer);
    // @ts-ignore
    let dataObject: [{ TimeStamp: number; DataValue: Decimal }] = [];

    for (let i=0; i<data.length; i+=12) {

      dataObject.push({
        TimeStamp: new Int64LE(data.buffer, i).toNumber(),
        DataValue: new Decimal(view.getFloat32(i + 8, true))
      });

    }

    return(dataObject);
  }

  public static getHrvBreakdown(scan: Scan, isChild?: boolean): HrvScanBreakdown {
    const stats: HrvScanBreakdown = {} as HrvScanBreakdown;
    stats.ScoreVersion = '2.0';
    const hrvScanData: HRVScanData = scan.ScanData[0] as HRVScanData;
    stats.Aa = new Decimal(hrvScanData.AutonomicActivity);
    stats.Ab = new Decimal(hrvScanData.AutonomicBalance);
    stats.Rest = new Decimal(60000).dividedBy(hrvScanData.MeanIBI);

    /*
    // Get AA
    let sum = 22 * Math.log10(hrvScanData.HFIBI + hrvScanData.LFIBI) + 5;
    if (sum < 20) sum = 20;
    stats.Aa = new Decimal(sum);

    // Get Ab
    const A = Math.sqrt(hrvScanData.LFIBI);
    const B = Math.sqrt(hrvScanData.HFIBI);
    const rawBalance = ((A - B) / (A + B))+ 0.16667;
    let sngBalance = 0;
    if (Math.abs(rawBalance) >0.65) {
      sngBalance = 20;
    } else {
      sngBalance = 100 - (123.077 * Math.abs(rawBalance));
    }

    if (rawBalance == 0) {
      stats.Ab = new Decimal(100);
    } else {
      stats.Ab = new Decimal(sngBalance);
    }
    */

    // Get Score
    if (stats.Aa.lessThan(100)) {
      // return (0.65F * aa) + (0.35F * ab);
      stats.Score = (stats.Aa.times(0.65)).plus((stats.Ab.times(0.35)));
    } else {
      // return 65F + (0.35F * ab);
      stats.Score = ((stats.Ab).times(0.35)).plus(65);
    }

    // Get Zone
    if(stats.Aa.greaterThan(78) && (stats.Ab.greaterThan(80) && (stats.Ab.lessThan(160))))
    {
      stats.Zone = 5;
    } else if (stats.Aa.greaterThan(68)) {
      if (hrvScanData.ABIndicator) {
        stats.Zone = 2;
      } else {
        stats.Zone = 1;
      }
    } else {
      if (hrvScanData.ABIndicator) {
        stats.Zone = 4;
      } else {
        stats.Zone = 3;
      }
    }

    // Get Aa Rating
    if (stats.Aa.greaterThanOrEqualTo(110)) {
      stats.AaRating = "Excellent";
    } else if (stats.Aa.greaterThanOrEqualTo(90)) {
      stats.AaRating = "Very Good";
    } else if (stats.Aa.greaterThanOrEqualTo(72)) {
      stats.AaRating = "Good";
    } else if (stats.Aa.greaterThanOrEqualTo(50)) {
      stats.AaRating = "Transition";
    } else {
      stats.AaRating = "Challenged";
    }

    // Get Ab Rating
    if (stats.Ab.greaterThanOrEqualTo(70)) {
      stats.AbRating = "Balanced";
    } else if (stats.Ab.greaterThanOrEqualTo(35)) {
      stats.AbRating = "Unbalanced";
    } else {
      stats.AbRating = "Highly Unbalanced";
    }

    // Get Rest Rating
    if (stats.Rest.greaterThanOrEqualTo(101)) {
      stats.RestRating = "Elevated";
    } else if (stats.Rest.greaterThanOrEqualTo(81)) {
      stats.RestRating = "Increased";
    } else {
      stats.RestRating = "Normal";
    }

    if(isChild) {
      stats.RestRating = "Normal";
    }

    // Rating
    if(stats.Aa.greaterThanOrEqualTo(77)) {
      stats.Rating = "Enough";
    } else {
      stats.Rating = "Less than ideal";
    }
    stats.Score = stats.Score.ceil();

    return stats;
  }

  public static filterHrvIbi(scan: Scan): any {
    const sd = scan.ScanData[0] as HRVScanData;
    const rawPpg = sd.RawPpgDecoded.filter((d) => d.TimeStamp != 0 && !d.DataValue.equals(0));

    const meanBpm = new Decimal(60000).dividedBy(sd.MeanIBI);
    const bpmTop = meanBpm.plus(meanBpm.mul(this.HrvBpmWindow));
    const bpmBot = meanBpm.minus(meanBpm.mul(this.HrvBpmWindow));

    const newData = [];

    for (const rd of rawPpg) {
      const hr = new Decimal(60000).dividedBy(rd.DataValue);
      if (hr.greaterThan(bpmBot) && hr.lessThan(bpmTop)) { newData.push(rd); }
    }

    return newData;
  }

  public static normalizeHrvScr(scan: Scan): any {
    const sd = scan.ScanData[0] as HRVScanData;
    const rawScr = sd.RawScrDecoded.filter((d) => d.TimeStamp != 0 && !d.DataValue.equals(0));

    const lisasMagicScaleStart = new Decimal(0);
    const lisasMagicScaleEnd = new Decimal(10);

    const mean = new Decimal(rawScr.reduce((a, b) => a + b.DataValue.toNumber(), 0) / rawScr.length);
    const min = new Decimal(Math.min(...rawScr.map((d) => d.DataValue.toNumber())));

    const newData = [];

    // Pulled from lisas "Rescale Function"
    for (const rd of rawScr) {
      const x = rd.DataValue;

      const b = mean.minus(min).eq(0) ? new Decimal(1).div(mean) : mean.minus(min);
      const uninterpolated = x.minus(min).div(b);

      const interpolated = lisasMagicScaleStart.mul(new Decimal(1).minus(uninterpolated)).plus(lisasMagicScaleEnd.mul(uninterpolated));

      newData.push({
        TimeStamp: rd.TimeStamp,
        DataValue: interpolated,
      });
    }

    return newData;
  }

  public static pinPathCubicBezier(width, height) {
    const deltaX = width * Math.sqrt(3);
    const deltaY = height * 4 / 3;
    return `M 0,0 C ${-deltaX},${-deltaY}
        ${deltaX},${-deltaY} 0,0 z`;
  }

  private static getBandValues(data: EMGScanData): {leftBand, rightBand} {
    const normData = this.EmgCalcData[data.SpinalLocation];

    let leftBand, rightBand;
    // Left
    let upper = normData.LeftMean - normData.LeftSd;

    if (data.LeftValue.lessThanOrEqualTo(upper)) {
      leftBand = -1;
    } else {
      for (let i = 1; i <= 3; i++) {
        upper = normData.LeftMean + (normData.LeftSd * i);
        if (data.LeftValue.lessThanOrEqualTo(upper)) {
          leftBand = i;
          break;
        }
      }

      if (!leftBand) { leftBand = 4; }
    }

    // Right
    upper = normData.RightMean - normData.RightSd;

    if (data.RightValue.lessThanOrEqualTo(upper)) {
      rightBand = -1;
    } else {
      for (let i = 1; i <= 3; i++) {
        upper = normData.RightMean + (normData.RightSd * i);
        if (data.RightValue.lessThanOrEqualTo(upper)) {
          rightBand = i;
          break;
        }
      }

      if (!rightBand) { rightBand = 4; }
    }

    return {leftBand, rightBand};
  }

  private static calcEmgScaleFactor(scan: Scan): Decimal {
    let skippedCount = 0;
    let skippedMeans = new Decimal(0);

    let abnormalCount = 0;
    let abnormals = new Decimal(0);
    let abnormalMeans = new Decimal(0);

    let readingSum = new Decimal(0);
    let meanSum = new Decimal(0);

    // Loop through all data
    for (const data of scan.ScanData) {
      const sd = data as EMGScanData;

      const {leftBand, rightBand} = this.getBandValues(sd);
      const normData = this.EmgCalcData[sd.SpinalLocation];

      // If the readings are hypo or normal, we will 'skip' them
      if (leftBand <= 1 && sd.LeftValue.equals(0) && normData.LeftMean != 0) {
        skippedCount++;
        skippedMeans = skippedMeans.plus(normData.LeftMean);
      } else if (leftBand > 1) {
        // Otherwise, we will keep track of the abnormal readings along with their means
        abnormalCount++;
        abnormals = abnormals.plus(sd.LeftValue);
        abnormalMeans = abnormalMeans.plus(normData.LeftMean);
      }

      if (rightBand <= 1 && sd.RightValue.equals(0) && normData.RightMean != 0) {
        skippedCount++;
        skippedMeans = skippedMeans.plus(normData.RightMean);
      } else if (rightBand > 1) {
        abnormalCount++;
        abnormals = abnormals.plus(sd.RightValue);
        abnormalMeans = abnormalMeans.plus(normData.RightMean);
      }

      readingSum = readingSum.plus(sd.LeftValue).plus(sd.RightValue);
      meanSum = meanSum.plus(normData.LeftMean).plus(normData.RightMean);
    }

    // Per Lisas code, throw out data that is less than this 'dev limit'
    let devLimit = 10;

    if (skippedCount > 0) {
      devLimit = (30 - skippedCount) * 0.3;
    }

    // If its less than the 'dev limit' we add back in the skipped values
    if (abnormalCount <= devLimit) {
      abnormalMeans = abnormalMeans.plus(skippedMeans);
    } else {
      abnormalMeans = skippedMeans;
      abnormals = new Decimal(0);
    }

    return meanSum.minus(abnormalMeans).dividedBy(readingSum.minus(abnormals));
    // return new Decimal(1)
  }

  public static getRomLabel(test: RomTestTypes, result: RomResultTypes): string {
    switch (test) {
      case RomTestTypes.CervicalFlexionExtension:
        return 'Cervical ' + RomResultTypes[result];

      case RomTestTypes.CervicalLateralFlexion:
        return result == RomResultTypes.LeftLateralBending ? 'Cervical Left Bend' : 'Cervical Right Bend';

      case RomTestTypes.CervicalRotation:
        return result == RomResultTypes.LeftRotation ? 'Cervical Left Rotation' : 'Cervical Right Rotation';

      case RomTestTypes.ThoracicKyphosis:
        return 'Thoracic Kyphosis';

      case RomTestTypes.ThoracicRotation:
        return result == RomResultTypes.LeftRotation ? 'Thoracic Left Rotation' : 'Thoracic Right Rotation';

      case RomTestTypes.LumbosacralFlexionExtension:
        return 'Lumbosacral  ' + RomResultTypes[result];

      case RomTestTypes.LumbosacralLateralFlexion:
        return result == RomResultTypes.LeftLateralBending ? 'Lumbosacral Left Bend' : 'Lumbosacral Right Bend';
    }
  }

  public static getRomNameForTest(test: RomTestTypes): string {
    switch (test) {
      case RomTestTypes.CervicalFlexionExtension:
        return 'Cervical Flexion-Extension';

      case RomTestTypes.CervicalLateralFlexion:
        return 'Cervical Lateral Flexion';

      case RomTestTypes.CervicalRotation:
        return 'Cervical Rotation';

      case RomTestTypes.ThoracicKyphosis:
        return 'Thoracic Kyphosis';

      case RomTestTypes.ThoracicRotation:
        return 'Thoracic Rotation';

      case RomTestTypes.LumbosacralFlexionExtension:
        return 'Lumbosacral Flexion-Extension';

      case RomTestTypes.LumbosacralLateralFlexion:
        return 'Lumbosacral Lateral Flexion';

      default:
        return '';
    }
  }

  public static getRomNorm(test: RomTestTypes, result: RomResultTypes): number {
    switch (test) {
      case RomTestTypes.CervicalFlexionExtension:
        return result == RomResultTypes.Flexion ? 50 : 60;

      case RomTestTypes.CervicalLateralFlexion:
        return 45;

      case RomTestTypes.CervicalRotation:
        return 80;

      case RomTestTypes.ThoracicKyphosis:
        return 50;

      case RomTestTypes.ThoracicRotation:
        return 30;

      case RomTestTypes.LumbosacralFlexionExtension:
        return result == RomResultTypes.Flexion ? 60 : 25;

      case RomTestTypes.LumbosacralLateralFlexion:
        return 25;
    }
  }

  public static getRomBreakdown(scan: Scan): RomScanBreakdown {
    const stats: RomScanBreakdown = {} as RomScanBreakdown;
    stats.ScoreVersion = '2024.03.12';
    const impairments = {
      cervical: [],
      cervicalRegion: 0,
      lumbar: [],
      lumbarRegion: 0,
      thoracic: [],
      thoracicRegion: 0,
      allRegions: [],
      all: [],
      preScore: new Decimal(0),
    };
    for (const scandata of scan.ScanData) {
      const sd = scandata as ROMScanData;
      let norm = this.getRomNorm(sd.TestType, sd.ResultType);
      let impairmentTest = norm - sd.DataValue;
      let impairment = 1 - (sd.DataValue/norm)
      impairment = impairmentTest <= 0 ? 0 : impairment * 100;
      switch (sd.TestType) {
        case RomTestTypes.CervicalLateralFlexion:
        case RomTestTypes.CervicalRotation:
        case RomTestTypes.CervicalFlexionExtension:
          if(impairment <= 0) break;
          impairments.cervical.push(impairment/100);
          break;
        case RomTestTypes.LumbosacralLateralFlexion:
        case RomTestTypes.LumbosacralFlexionExtension:
          if(impairment <= 0) break;
          impairments.lumbar.push(impairment/100);
          break;
        case RomTestTypes.ThoracicRotation:
        case RomTestTypes.ThoracicKyphosis:
          if(impairment <= 0) break;
          impairments.thoracic.push(impairment/100);
          break;
      }
      if(impairment <= 0) continue;
      impairments.all.push(impairment/100);
    }

    // A region with no impaired tests contributes 0 (spineROM has no thoracic tests, so 0/0 gave NaN)
    const regionScore = (region: number[]) => region.length > 0 ? 1 - (region.reduce((a, b) => a + b, 0) / region.length) : 0;
    impairments.cervicalRegion = regionScore(impairments.cervical);
    impairments.lumbarRegion = regionScore(impairments.lumbar);
    impairments.thoracicRegion = regionScore(impairments.thoracic);

    /*
    impairments.cervical.forEach((c,index) => {
      if(index == 0) {
        impairments.cervicalRegion = c;
        return;
      }
      impairments.cervicalRegion = impairments.cervicalRegion + c * (1 - impairments.cervicalRegion);
    });
    impairments.lumbar.forEach((c,index) => {
      if(index == 0) {
        impairments.lumbarRegion = c;
        return;
      }
      impairments.lumbarRegion = impairments.lumbarRegion + c * (1-impairments.lumbarRegion);
    });
    impairments.thoracic.forEach((c,index) => {
      if(index == 0) {
        impairments.thoracicRegion = c;
        return;
      }
      impairments.thoracicRegion = impairments.thoracicRegion + c * (1-impairments.thoracicRegion);
    });
     */

    if(impairments.cervical.length > 0) impairments.allRegions.push(impairments.cervicalRegion);
    if(impairments.lumbar.length > 0) impairments.allRegions.push(impairments.lumbarRegion);
    if(impairments.thoracic.length > 0) impairments.allRegions.push(impairments.thoracicRegion);
    if(impairments.all.length > 0) {
      impairments.preScore = new Decimal(impairments.cervicalRegion + impairments.lumbarRegion + impairments.thoracicRegion).dividedBy(impairments.all.length);
    } else {
      impairments.preScore = new Decimal(0);
    }

    stats.Score = (new Decimal(1).minus(impairments.preScore)).times(100);
    stats.Score = stats.Score.greaterThan(100) ? new Decimal(100) : stats.Score;
    stats.Score = stats.Score.lessThan(20) ? new Decimal(20) : stats.Score;
    return stats;
  }

  public static getAlgoBarColor(dataItem: AlgoScanData, dataArray: AlgoScanData[]) : any {
    const baseline = this.getAlgoBaseLine(dataItem,dataArray);
    let impairment = new Decimal(0);
    if(dataItem.LeftValue.greaterThan(0)) {
      impairment = dataItem.LeftValue.dividedBy(baseline.LeftValue);
    } else if(dataItem.CenterValue.greaterThan(0)) {
      impairment = dataItem.CenterValue.dividedBy(baseline.CenterValue);
    } else if(dataItem.RightValue.greaterThan(0)) {
      impairment = dataItem.RightValue.dividedBy(baseline.RightValue);
    }

    if(impairment.greaterThanOrEqualTo(0.9)) {
      return [0, colorGreen, 1, colorGreenEnd];
    }
    if(impairment.greaterThanOrEqualTo(0.8)) {
      return [0, colorBlue, 1, colorBlueEnd];
    }
    return [0, colorRed, 1, colorRedEnd];
  }

  public static getAlgoBreakdown(scan: Scan): AlgoScanBreakdown {
    const stats: AlgoScanBreakdown = {
      ScoreVersion: '2.0',
      Asymmetries: [],
      Impairments: []} as AlgoScanBreakdown;
    stats.Score = new Decimal(0);

    let sd = scan.ScanData as AlgoScanData[];
    for(let algoData of sd.sort((a: AlgoScanData, b: AlgoScanData) => a.SpinalLocation - b.SpinalLocation )) {
      // check for asym
      if(!algoData.BaselineFlag && algoData.LeftValue.greaterThan(0) && algoData.RightValue.greaterThan(0)) {
        let asym = algoData.LeftValue.minus(algoData.RightValue).abs().dividedBy(algoData.LeftValue.plus(algoData.RightValue));
        stats.Asymmetries.push(asym);
      }
      // check for impairment
      let baseLine = this.getAlgoBaseLine(algoData, sd);
      if(!baseLine) continue;

      if(algoData.LeftValue.greaterThan(0) && !algoData.BaselineFlag) {
        let impairment = algoData.LeftValue.dividedBy(baseLine.LeftValue)
        impairment = impairment.greaterThan(1) ? new Decimal(1) : impairment;
        stats.Impairments.push(impairment);
      }
      if(algoData.RightValue.greaterThan(0) && !algoData.BaselineFlag) {
        let impairment = algoData.RightValue.dividedBy(baseLine.RightValue)
        impairment = impairment.greaterThan(1) ? new Decimal(1) : impairment;
        stats.Impairments.push(impairment);
      }
      if(algoData.CenterValue.greaterThan(0) && !algoData.BaselineFlag) {
        let impairment = algoData.CenterValue.dividedBy(baseLine.CenterValue)
        impairment = impairment.greaterThan(1) ? new Decimal(1) : impairment;
        stats.Impairments.push(impairment);
      }
    }
    if(stats.Impairments.length == 0 && stats.Asymmetries.length ==0) {
      stats.Score = new Decimal(100);
      return;
    }

    if(stats.Impairments.length == 0) {
      stats.ImpairmentScore = new Decimal(1);
    } else {
      // Pad to at least 3
      for(let i = stats.Impairments.length; i < 3; i++) {
        stats.Impairments.push(new Decimal(1));
      }

      // Sort
      stats.Impairments.sort((a: Decimal, b: Decimal) => a.minus(b).toNumber());
      // Score
      let length = stats.Impairments.length;
      stats.ImpairmentScore = (stats.Impairments[length - 1].plus(stats.Impairments[length - 2]).plus(stats.Impairments[length - 3])).dividedBy(3);
    }

    if(stats.Asymmetries.length == 0) {
      stats.AsymmetryScore = new Decimal(0);
    } else {
      // Pad to at least 3
      for(let i = stats.Asymmetries.length; i < 3; i++) {
        stats.Asymmetries.push(new Decimal(0));
      }
      // Sort
      stats.Asymmetries.sort((a: Decimal, b: Decimal) => a.minus(b).toNumber());
      // Score
      length = stats.Asymmetries.length;
      stats.AsymmetryScore = (stats.Asymmetries[length - 1].plus(stats.Asymmetries[length-2]).plus(stats.Asymmetries[length - 3])).dividedBy(3);
    }

    if ((!stats.ImpairmentScore.equals(1)) && (!stats.AsymmetryScore.equals(0)))
    {
      stats.Score = stats.ImpairmentScore.times(0.8).plus((new Decimal(1).minus(stats.AsymmetryScore)).times(0.2)).times(100);
    }
    if ((stats.ImpairmentScore.equals(1)) && (!stats.AsymmetryScore.equals(0)))// no impairment score
    {
      stats.Score = (new Decimal(1).minus(stats.AsymmetryScore)).times(100);
    }
    if ((!stats.ImpairmentScore.equals(1)) && (stats.AsymmetryScore.equals(0)))// no asym score
    {
      stats.Score = stats.ImpairmentScore.times(100);
    }

    stats.Score = stats.Score.greaterThan(100) ? new Decimal(100) : stats.Score;

    return stats;
  }

  public static getAlgoBaseLine(reading: AlgoScanData, sd: AlgoScanData[]): AlgoScanData
  {
    let maxLocation: SpinalLocation = SpinalLocation.S1;
    let minLocation: SpinalLocation = SpinalLocation.S1;
    if(reading.SpinalLocation <= SpinalLocation.C7) {
      minLocation = SpinalLocation.C1;
      maxLocation = SpinalLocation.C7;
    } else if (reading.SpinalLocation <= SpinalLocation.T6) {
      minLocation = SpinalLocation.T1;
      maxLocation = SpinalLocation.T6;
    } else if (reading.SpinalLocation <= SpinalLocation.T12) {
      minLocation = SpinalLocation.T7;
      maxLocation = SpinalLocation.T12;
    } else if (reading.SpinalLocation <= SpinalLocation.L5) {
      minLocation = SpinalLocation.L1;
      maxLocation = SpinalLocation.L5;
    }

    let leftBaseline = sd.find((value,index,obj) =>
      value.SpinalLocation <= maxLocation
      && value.SpinalLocation >= minLocation
      && value.BaselineFlag == true
      && value.LeftValue.greaterThan(0) == reading.LeftValue.greaterThan(0)) as AlgoScanData;
    let rightBaseline = sd.find((value,index,obj) =>
      value.SpinalLocation <= maxLocation
      && value.SpinalLocation >= minLocation
      && value.BaselineFlag == true
      && value.RightValue.greaterThan(0) == reading.RightValue.greaterThan(0)) as AlgoScanData;
    let centerBaseline = sd.find((value,index,obj) =>
      value.SpinalLocation <= maxLocation
      && value.SpinalLocation >= minLocation
      && value.BaselineFlag == true
      && value.CenterValue.greaterThan(0) == reading.CenterValue.greaterThan(0)) as AlgoScanData;

    return <AlgoScanData>{
      SpinalLocation: leftBaseline.SpinalLocation,
      BaselineFlag: true,
      LeftValue: leftBaseline.LeftValue,
      RightValue: rightBaseline.RightValue,
      CenterValue: centerBaseline.CenterValue
    }
  }

  public static translateExam(language){
    let exam = 'Exam';
    switch (language) {
      case 'English':
        exam = ' Exam ';
        break;
      case 'French':
        exam = ' Examen ';
        break;
      case 'German':
        exam = ' Prüfung ';
        break;
      case 'Spanish':
        exam = ' Examen ';
        break;
      case 'Norwegian':
        exam = ' Eksamen ';
        break;
      case 'Italian':
        exam = ' Esame ';
        break;
      case 'Dutch':
        exam = ' Scan ';
        break;
      case 'Portuguese':
        exam = ' Exame ';
        break;
    }
    return exam;
  }

}
ScanViewUtils.init();

// We can use decimal.js if needed
interface CalcData {
  LeftSd: number;
  RightSd: number;
  LeftMean: number;
  RightMean: number;
}



// WEBPACK FOOTER //
// ./src/components/scan-view/scan-view.ts